import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Redirect } from "react-router-dom";

import Logger from '../functions/logging';

import '../static/pilotly.css';
import '../static/register/Register.css';
import '../static/register/AmazonReadyToBegin.css';

import register from '../api/register';
import login from '../api/login';
import * as TargetProcess from '../functions/targetProcess';

import { getDistributionList, updateDistributionList } from '../api/distributionList';
import { getStudyPanel } from '../api/panels';
import { getEpisode } from '../api/episode';
import { getGroup, getDeepGroup, getSVODGroup, getGroupPanelSegment, groupJoinSubscription, groupSubscribe } from '../api/group';
import { getUser, isEmailInUse, getLocationByZipcode, updateViewerMetadata, completeAllUserQuestionAssignments } from '../api/user';
import { setPlayerSessionQuotaMethods } from '../api/player';
import { submitPollResponseWithQuestionTid, createRegistrationResponses } from '../api/responses';

import * as auth from '../functions/auth';
import * as helpers from '../functions/helpers';
import { getLanguageWithoutRegionCode, getLocale } from '../functions/locale';
import { loadUserLocation, isUserInUS } from '../functions/geolocation';

import FadeIn from '../components/global/FadeIn';
import PageLoader from '../components/global/PageLoader';
import Feedback from '../components/global/Feedback';
import { Button } from "../components/global/Button";
import { cloneDeep } from 'lodash';
import { isModerated, getSELCodes, isDesktopEnabledStudy, isMobileWebEnabledStudy } from "../functions/study";
import { formatGender, isNumber, isValidAge, returnEthnicityRecode } from "../functions/utils";

import RegisterReadyToBegin from './RegisterReadyToBegin';
import AmazonRegisterToBegin from './AmazonReadyToBegin';
import QualtricsReadyToBegin from './QualtricsReadyToBegin';

import localeMessages from '../locales/register';
import localeEducation from '../locales/education';
import localeEthnicity from '../locales/ethnicity';
import localeCountry from '../locales/country';
import {
	AMERICAN_INDIAN,
	ASIAN_INDIAN,
	AFRICAN_AMERICAN,
	NATIVE_HAWAIIAN_PACIFIC_ISLANDER,
	CAUCASIAN_WHITE,
	OTHER,
	NOT_AVAILABLE
} from '../constants/ethnicityCodes';

/* Google analytics */
import SessionStatus from '../analytics/analytics-events/SessionStatus';
import { SessionStatusEvent } from '../analytics/analytics-events/constants';

import { 
	setTargetParams, 
	setFetchedDistributionList,
	setFetchedGroup, 
	setFetchedGroupPanelSegment,
	setFetchedEpisode, 
	setFetchedPanel,
	setCurrentUser,
	setUserDisclaimer,
	setPanelPartner,
} from '../redux/actions/index';

import {
	MAX_AGE_RESTRICTION, 
	MIN_AGE_RESTRICTION, 
	VIDEO_RESPONSE_CONSENT,
	VIEWER_NDA_CONSENT,
	ACCEPT_TERMS_N_CONDITIONS
} from '../constants/registrationConstants';
import { FILTERED_REGISTRATION_CODE } from '../constants/screenCodes';
import { enableFullscreen } from '../functions/fullscreen';

import DeviceHelper from '../functions/device';

/* afc=17 age for consent*/ 
const PILOTLY_TESTER_USER = "pilotly-tester";
const SUB_PARAMS = ['list', 'group'];

class Register extends Component {
	constructor(props) {
		super(props);

		let fakeUser = null;
		const isTester = TargetProcess.isTester(this.props.targetParams);
		
		if (isTester && props.targetParams && props.targetParams.regfill && parseInt(props.targetParams.regfill) === 1) {
			let genders = ['m', 'f'].sort(() => 0.5 - Math.random());
			fakeUser = {
				firstname: "Portal",
				lastname: "User",
				email: "portaltest" + (new Date()).getTime() + "@example.com",
				password: "Passw0rd",
				date_of_birth: "01/01/1995",
				age: "25",
				gender: genders[0],
				zipcode: "48210"
			};
			Logger.log(Register.name, "constructor() fakeUser", fakeUser);
		}
		else if (props.targetParams && isNumber(props.targetParams.demo) && Number(props.targetParams.demo) === 1) {
			fakeUser = {
				email: "portaldemo" + (new Date()).getTime() + "@example.com",
				password: "Passw0rd",
			};
			Logger.log(Register.name, "constructor() fakeUser", fakeUser);
		}

		fakeUser = props.targetParams && props.targetParams.fakeUser ? props.targetParams.fakeUser : fakeUser;
		let displayRegistration = props.targetParams && props.targetParams.gid ? false : true;

		const userLocation = loadUserLocation();
		const isInternationalUser = this.isInternationalUser(props.targetParams);
		const addGenderNeutral = this.checkGenderNeutralOption(props.targetParams);
		const displayEthnicityFields = this.checkEthnicityFieldsEnabled(props.targetParams);

		const url = new URL(window.location.origin + auth.getSavedUrl());
		const requiresTechCheck = url.searchParams.get('tech') === "1";
		const languageWithoutRegionCode = getLocale() || (props.targetParams && props.targetParams.lang) || getLanguageWithoutRegionCode();
		Logger.log(this.constructor.name, "componentDidUpdate() LANGUAGE:", languageWithoutRegionCode);

		this.state = {
			requiresTechCheck,

			displayRegistration: displayRegistration,
			isListenersAdded: false,
			isWindowSelectSet:false,
			isEthnicitySelectSet: false,
			isEducationSelectSet: false,
			isCountrySelectSet: false,
			loading: false,
			continueRegistration: false,

			checkedRealUser: false,
			realUser: false,
			errors: {},
			user: {
				fullname: fakeUser ? fakeUser.firstname + " " + fakeUser.lastname : "",
				firstname: fakeUser ? fakeUser.firstname : "",
				lastname: fakeUser ? fakeUser.lastname : "",
				date_of_birth: fakeUser && fakeUser.date_of_birth ? fakeUser.date_of_birth : "",
				age: fakeUser && fakeUser.age ? fakeUser.age : "",
				gender: fakeUser && fakeUser.gender ? fakeUser.gender : "",
				email: fakeUser ? fakeUser.email : "",
				zipcode: isInternationalUser ? "INTL" : (fakeUser && fakeUser.zipcode ? fakeUser.zipcode : ""),
				country: (userLocation ? userLocation.country_code : ""),
				isInternationalUser: isInternationalUser,
				household_income: "",
				language: languageWithoutRegionCode,
				ethnicity_hispanic: displayEthnicityFields ? 0 : null,
				ethnicity_race: [],
				education: "",
				password: fakeUser ? fakeUser.password : ""
			},

			parentGuardian: {
				type: null,
				date_of_birth: fakeUser && fakeUser.date_of_birth ? fakeUser.date_of_birth : "",
				age: fakeUser && fakeUser.age ? fakeUser.age : "",
				parental_consent: false
			},

			addGenderNeutral: addGenderNeutral,

			userAcceptedVideoDisclaimer: false,
			userAcceptedViewerConsentDisclaimer: false,
			userEligible: true, 
			userStudyStatus: null,
			userAuthEmail: null,
			badUrl: null,

			steps: ['viewer_description', 'fullname', 'date_of_birth', 'child_date_of_birth', 'parental_consent', 'gender', 'email', 'country', 'zipcode', 'household_income', 'ethnicity_hispanic', 'ethnicity_race', 'education', 'password'],

			// steps: ['fullname', 'date_of_birth', 'gender', 'email', 'country', 'zipcode', 'household_income', 'ethnicity', 'education', 'password'],

			step: 0,
			subscribed: false,
			updatedViewerMetadata: false,

			fetchedDistributionList: null,
			fetchedGroup: null,
			fetchedGroupPanelSegment: null,
			fetchedEpisode: null,

			buttonWaiting: false,
			email_obfuscated: null,
			panel: null,
			isValidEnvironment: true
		};

		this.ethnicityResponseGenerated = false;

		this._viewerDiscription = React.createRef();
		this._fullname         = React.createRef();
		this._dateOfBirth      = React.createRef();
		this._childDateOfBirth = React.createRef();
		this._parentalConsent  = React.createRef();
		this._gender           = React.createRef();
		this._email            = React.createRef();
		this._country          = React.createRef();
		this._zipcode          = React.createRef();
		this._houseHoldIncome  = React.createRef();
		this._ethnicityHispanic = React.createRef();
		this._ethnicityRace    = React.createRef();
		this._education        = React.createRef();
		this._password         = React.createRef();

		this.saveUser = this.saveUser.bind(this);
		this.setDistributionList = this.setDistributionList.bind(this);

		this.handleNext            = this.handleNext.bind(this);
		this.handlePrevious        = this.handlePrevious.bind(this);
		this.handleChange          = this.handleChange.bind(this);
		this.handleDateChange      = this.handleDateChange.bind(this);
		this.handleParentalConsent = this.handleParentalConsent.bind(this);
		this.handleGenderChange    = this.handleGenderChange.bind(this);
		this.handleCountrySelect   = this.handleCountrySelect.bind(this);
		this.handleEthnicitySelect = this.handleEthnicitySelect.bind(this);
		this.handleEducationSelect = this.handleEducationSelect.bind(this);

		this.validateAuthedUser     = this.validateAuthedUser.bind(this); 
		this.validateUserEligiblity = this.validateUserEligiblity.bind(this);

		this.getInputFieldClass = this.getInputFieldClass.bind(this);

		this.focusInput = this.focusInput.bind(this);
	}

	static getStringDifference(string1, string2) {
		let i = 0;
		let j = 0;
		let result = "";

		while (j < string2.length) {
			if (string1[i] !== string2[j] || i === string1.length) {
				result += string2[j];
			} else {
				i++;
			}
			j++;
		}
		return result;
	}

	componentDidMount() {
		Logger.log(this.constructor.name, "componentDidMount()", this.props);
		const { targetParams, globalAnalyticsAdapter } = this.props;

		this.setDocumentSelect();
		this.addFormListeners();

		if (!targetParams) {
			const savedUrl = auth.getSavedUrl();
			if (savedUrl) {
				this.props.history.push(savedUrl);
				return;
			}
		}

		const isPartner = targetParams && targetParams.partner;

		Logger.log(this.constructor.name, 'componentDidMount() targetParams', targetParams);
		
		/* Google analytics event */
		let sessionStatus = new SessionStatus(SessionStatusEvent.SESSION_STARTED, '', '', false, false, true);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.state = isPartner ? 'Partner User' : 'Pilotly User';
		sessionStatus.type = isPartner ? targetParams.partner : 'Pilotly';
		globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

		let errors = TargetProcess.validateParams(targetParams);
		if(errors && !this.state.badUrl) this.setState({badUrl: errors});

		// get the user object if user_token exists
		let user_token = auth.getToken();
		if (user_token && 
			targetParams && 
			(targetParams.partner || targetParams.dl) && 
			!targetParams.videoDisclaimer
		) {
			user_token = null;
			auth.logout(() => {
				this.setState({ realUser: false });
				this.props.setCurrentUser(null);
			});
		} 
		else if (user_token 
			&& (!targetParams 
				|| (!targetParams.partner 
				&& !targetParams.dl))
		) {
			this.loadUser(user_token);
		}

		// if distribution list parameter exists get the distribution list obj
		if (targetParams 
			&& targetParams.dl
		) {
			this.loadDistributionList(targetParams.dl);
		}

		// if study is using a third party url save it in local storage
		if (targetParams 
			&& targetParams.thirdPartyUrl 
			&& TargetProcess.isResumeEnabled(targetParams)
		) {
			auth.setThirdPartyUrl(targetParams.thirdPartyUrl);
		}

		// if distribution list and email parameter exists try logging in the user
		if (targetParams 
			&& targetParams.dl 
			&& targetParams.fakeUser
		) {
			let userEmail = targetParams.fakeUser.email;
			let userPassword = btoa(userEmail); // using the provided email as the password
			userPassword = userPassword.replace('==', '');
			this.createUserAuth(userEmail, userPassword, true);
		}
		// if the study is using a partner list use fake user info to attempt a login
		else if (targetParams 
			&& targetParams.partner 
			&& targetParams.fakeUser
		) {
			let partnerUserEmail = targetParams.fakeUser.email;
			let partnetUserPassword = targetParams.fakeUser.password;
			this.createUserAuth(partnerUserEmail, partnetUserPassword, true);
		}
		else {
			this.setState({ continueRegistration: true });
		}

		// get the study if gid parameter exists
		if (targetParams && targetParams.gid) {
			this.loadGroup(targetParams.gid);
		}

		if (this.props.currentUser && targetParams) {
			this.checkUserCompletionStatus(this.props.currentUser, targetParams.gid);
		}

		if (user_token && 
			targetParams && 
			(!targetParams.fakeUser || targetParams.partner)
		) {
			this.setState({ realUser: true });
		}
	}

	componentDidUpdate(prevProps) {
		Logger.log(this.constructor.name, "componentDidUpdate()", prevProps, this.props);
		this.setDocumentSelect();

		const { targetParams } = this.props;

		let errors = TargetProcess.validateParams(targetParams);
		if(errors && !this.state.badUrl) this.setState({badUrl: errors});

		let user_token = auth.getToken();
		if(this.props.fetchedGroup 
			&& user_token 
			&& !this.props.fetchedEpisode 
			&& !this.state.fetchingEpisode
		) {
			this.setState({ 
				fetchingEpisode: true 
			}, () => {
				let episode_id = this.props.fetchedGroup.panel_segment && this.props.fetchedGroup.panel_segment[0] ? this.props.fetchedGroup.panel_segment[0].episode : "";
				this.loadEpisode(episode_id, user_token);
			});
		}

		if (user_token && !this.props.currentUser) this.loadUser(user_token);

		if (this.props.currentUser && 
			prevProps.currentUser && 
			targetParams && 
			(!this.state.userStudyStatus || !helpers.areObjectsTheSame(this.props.currentUser, prevProps.currentUser))
		) {
			this.checkUserCompletionStatus(this.props.currentUser, targetParams.gid);
		}

		if (this.props.currentUser 
			&& targetParams 
			&& targetParams.videoDisclaimer 
			&& !this.state.userAcceptedVideoDisclaimer
			&& helpers.checkUserAcceptedDisclaimers(this.props.currentUser, targetParams.gid, VIDEO_RESPONSE_CONSENT)
		) {
			this.setState({ userAcceptedVideoDisclaimer: true });
		}

		if (this.props.currentUser 
			&& targetParams 
			&& targetParams.viewerConsent 
			&& !this.state.userAcceptedViewerConsentDisclaimer
			&& helpers.checkUserAcceptedDisclaimers(this.props.currentUser, targetParams.gid, VIEWER_NDA_CONSENT)
		) {
			this.setState({ userAcceptedViewerConsentDisclaimer: true });
		}

		// move/validate user to study test if user is logged in as a real user and gid param exists
		if (user_token 
			&& this.state.displayRegistration 
			&& targetParams 
			&& (!targetParams.fakeUser || targetParams.partner) 
			&& !this.state.checkedRealUser
		) {
			this.setState({
				checkedRealUser: true
			}, () => {
				this.validateUserEligiblity();
				// if (TargetProcess.isResumeEnabled(targetParams)) {
				// }
			});
		}

		if (this.state.user 
			&& this.props.currentUserLocation 
			&& !prevProps.currentUserLocation
		) {
			let user = { ...this.state.user };
			const isInternationalUser = this.isInternationalUser(targetParams);
			user.country = (this.props.currentUserLocation ? this.props.currentUserLocation.country_code : null);
			user.isInternationalUser = isInternationalUser;

			if (!isInternationalUser && user.zipcode === "INTL") {
				user.zipcode = "";
			}
			this.setState({ user });
		}
	}

	isInternationalUser = (targetParams) => {
		const userInUS = !(isUserInUS() === false); // can be null if can't get info
		return !userInUS || (targetParams && targetParams.intl && targetParams.intl === "1");
	}

	checkGenderNeutralOption = (targetParams) => {
		return targetParams && targetParams.gen && targetParams.gen === "1";
	}

	checkEthnicityFieldsEnabled(targetParams) {
		return targetParams && (!targetParams.eth || targetParams.eth !== "0") && (!targetParams.intl || targetParams.intl !== "1");
	}

	setDocumentSelect() {
		if(!this.state.isWindowSelectSet && document.getElementsByTagName('select')) {
			this.setState({ isWindowSelectSet: true }, () => {
				window.$(document).ready(() => { window.$('select').formSelect(); });
			});
		}

		if (!this.state.isCountrySelectSet && document.getElementById('country')) {
			this.setState({ isCountrySelectSet: true }, () => {
				window.$(document).ready(() => { window.$('select').formSelect(); });
				window.$('#country').on('change', (e) => { this.handleCountrySelect(e); }).formSelect();
			});
		}

		if(!this.state.isEthnicitySelectSet && document.getElementById('ethnicity')) {
			this.setState({ isEthnicitySelectSet: true }, () => {
				window.$(document).ready(() => { window.$('select').formSelect(); });
				window.$('#ethnicity').on('change', (e) => { this.handleEthnicitySelect(e); }).formSelect();
			});
		}

		if(!this.state.isEducationSelectSet && document.getElementById('education')) {
			this.setState({ isEducationSelectSet: true }, () => {
				window.$(document).ready(() => { window.$('select').formSelect(); });
				window.$('#education').on('change', (e) => { this.handleEducationSelect(e); }).formSelect();
			});
		}
	}

	setDocumentSelectByName(selectType) {
		if (selectType) window.$(document).ready(() => { window.$('select').formSelect(); });
		switch (selectType) {
			case '_country':{
				window.$('#country').on('change', (e) => { this.handleCountrySelect(e); }).formSelect();
				break;
			}
			case '_ethnicityRace': {
				window.$('#ethnicity').on('change', (e) => { this.handleEthnicitySelect(e); }).formSelect();
				break;
			}
			case '_education': {
				window.$('#education').on('change', (e) => { this.handleEducationSelect(e); }).formSelect();
				break;
			}
		}
	}

	addFormListeners() {
		let self = this;
		if (!this.state.isListenersAdded) {
			this.setState({ isListenersAdded: true}, () => {
				document.addEventListener("keyup", (event) => {
					if (event.keyCode === 9) self.focusInput();
				});
			});
		}
	}

	focusInput() {
		let fieldStep = this.state.step;
		let errors = {...this.state.errors};
		let user = { ...this.state.user };
		let registerFields = this.renderRegisterFields(fieldStep, errors, user, this.state.parentGuardian, this.state.steps, true);
		let currentFieldRef = registerFields[fieldStep] ? registerFields[fieldStep] : null;

		if (currentFieldRef === "_ethnicityRace" || 
			currentFieldRef === "_education" || 
			currentFieldRef === "_country"
		) {
			this.setDocumentSelectByName(currentFieldRef);
		}

		if (currentFieldRef && this[currentFieldRef] && this[currentFieldRef].current && 
			(currentFieldRef !== "_viewerDiscription" &&
			currentFieldRef !== "_parentalConsent" &&
			currentFieldRef !== "_gender" && 
			currentFieldRef !== "_ethnicityRace" && 
			currentFieldRef !== "_education" && 
			currentFieldRef !== "_country")
		) {
			this[currentFieldRef].current.focus();
		}
		else if (currentFieldRef === "_ethnicityRace" && 
			document.querySelectorAll("#ethnicity_race-field input.select-dropdown") && 
			document.querySelectorAll("#ethnicity_race-field input.select-dropdown")[0]
		) {
			document.querySelectorAll("#ethnicity_race-field input.select-dropdown")[0].focus();
		}
		else if (currentFieldRef === "_education" && 
			document.querySelectorAll("#education-field input.select-dropdown") && 
			document.querySelectorAll("#education-field input.select-dropdown")[0]
		) {
			document.querySelectorAll("#education-field input.select-dropdown")[0].focus();
		}
		else if (currentFieldRef === "_country" && 
			document.querySelectorAll("#country-field input.select-dropdown") && 
			document.querySelectorAll("#country-field input.select-dropdown")[0]
		) {
			document.querySelectorAll("#country-field input.select-dropdown")[0].focus();
		}
	}

	/***** aync calls *****/
	async saveUser() {
		const { 
			targetParams,
			globalAnalyticsAdapter
		} = this.props;
		let user = {...this.state.user};
		user.ethnicity_recode = returnEthnicityRecode(user);
		const isReelChat = helpers.isReelChatStudy(targetParams);
		const provider = targetParams && targetParams.provider ? targetParams.provider : "NA";
		const sel = getSELCodes(targetParams);
		const age = user.age || Math.round(moment().diff(user.date_of_birth, 'years',true));
		if (!user.age) user.age = age;

		let email = user.email;
		let password = user.password;
		if (isReelChat 
			&& targetParams 
			&& targetParams.reelchatUser
			&& email
		) {
			password = targetParams.reelchatUser.password;
		}

		let fields = {
			age,
			sel,
			provider,
			email,
			password,
			firstname: user.firstname,
			lastname: user.lastname,
			dob: user.date_of_birth,
			gender: user.gender,
			hhi: user.household_income,
			zipcode: user.zipcode,
			country: user.country,
			language: user.language,
			ethnicity_hispanic: user.ethnicity_hispanic,
			ethnicity_race: user.ethnicity_race.toString(),
			ethnicity_recode: user.ethnicity_recode,
			education: user.education || user.education === 0 ? user.education : null,
		};

		if (this.state.email_obfuscated) {
			fields.email = this.state.email_obfuscated;
		}

		Logger.log(this.constructor.name, "saveUser() user:", user, fields);

		this.setState({ loading: true, user });

		/* Google analytics event */
		let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_BASIC_REGISTER, '', '', false, false, true);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.state = 'start';
		globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

		try {
			const result = await register(fields);
			if (result) {
				Logger.log(this.constructor.name, "saveUser() Register Successful", result);
				if(!this.props.targetParams || !this.props.targetParams.fakeUser) auth.setLogin(fields.email);
				auth.setToken(result);
				this.loadUser(result, this.validateUserEligiblity);
				// this.props.history.push("/home");

				/* Google analytics event */
				let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_BASIC_REGISTER, '', '', false, false, true);
				sessionStatus.gaTracker = this.props.tracker;
				sessionStatus.state = 'finish';
				globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
			}
			else {
				this.setState({ loading: false });
				Logger.log(this.constructor.name, "saveUser() Register Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
				this.setState({ errors });
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "saveUser() Register Failed", error);
			if (error.error === 403 || error.error === "accounts") {
				errors["status"]  = this.props.intl.formatMessage(localeMessages.error_login_incorrect);
			}
			else {
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_register_failed);
			}
			this.setState({ errors });
		}
	}

	async loadUser(user_token, callback) {
		const { user } = this.state;

		try {
			const result = await getUser(user_token);
			if (result) {
				Logger.log(this.constructor.name, "loadUser() User Success", result, user);

				if (!result.region && user.region) result.region = user.region;
				let metadata = this.getViewerMetadata(result, this.props.fetchedGroup);
				if (metadata && 
					metadata.type && 
					(metadata.type.includes('parent') || metadata.type.includes('child')) && 
					result.viewer_metadata && 
					result.viewer_metadata.length
				) {
					let parentGuardian = { ...this.state.parentGuardian };
					parentGuardian.type = metadata.type;
					parentGuardian.age = metadata.age;
					parentGuardian.parental_consent = metadata.parental_consent;
					this.setState({ parentGuardian });
				}

				this.props.setCurrentUser(result);

				if(callback) callback();
			}
			else {
				Logger.log(this.constructor.name, "loadUser() User Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_loading_user);
				this.setState({ errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadUser() User Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_loading_user);
			this.setState({ errors });
		}
	}

	sendAuthAutoLoginAnalyticsEvent = state => {
		const { globalAnalyticsAdapter } = this.props;
		/* Google analytics event */
		let sessionStatus = new SessionStatus(SessionStatusEvent.AUTH_AUTO_LOGIN, '', '', false, false, true);
		sessionStatus.gaTracker = this.props.tracker;
		sessionStatus.state = state;
		globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
	};
	
	async updateViewerMeta(user_token, currentUser, psIndex, parentGuardianFields) {
		try {
			let method = 'create';
			let metadata = this.getViewerMetadata(currentUser, this.props.fetchedGroup);
			if (metadata && currentUser.viewer_metadata && currentUser.viewer_metadata.length) {
				method = 'update';
				parentGuardianFields._id = metadata._id;
			}

			const result = await updateViewerMetadata(currentUser.user_id, user_token, psIndex, this.props.fetchedGroup._id, parentGuardianFields, method);
			if (result) {
				Logger.log(this.constructor.name, "updateViewerMeta() Meta Data Successful", result);
				if (method === 'create') this.props.setCurrentUser({ ...currentUser, viewer_metadata: [result] });
				if (result
					&& result.value
					&& result.value.redirect
					&& result.value.feedback_type
				) {
					const userStudyStatus = result.value.feedback_type;
					this.setState({ userStudyStatus });
				}
			}
			else {
				Logger.log(this.constructor.name, "updateViewerMeta() Meta Data Failed: No result token???");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_metadata_failed);
				this.setState({ errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "updateViewerMeta() Meta Data Failed", error);
			if (error.error === 403 || error.error === "accounts") {
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_metadata_failed);
			}
			else {
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_metadata_failed);
			}
			this.setState({ errors });
		}
	}

	async createUserAuth(userEmail, userPassword, autoLogin) {
		autoLogin ? this.sendAuthAutoLoginAnalyticsEvent('start') : null;
		try {
			const result = await login(userEmail, userPassword);
			if (result) {
				Logger.log(this.constructor.name, "createUserAuth() User Login Success", result);
				if (!this.props.targetParams || !this.props.targetParams.fakeUser) auth.setLogin(userEmail);
				if (this.props.targetParams && this.props.targetParams.fakeUser) auth.deletePortalEmail();
				this.setState({ continueRegistration: true });
				auth.setToken(result);
				this.loadUser(result);
				autoLogin ? this.sendAuthAutoLoginAnalyticsEvent('finish') : null;
			}
			else {
				Logger.log(this.constructor.name, "createUserAuth() User Login Failed: No result token???");
				autoLogin ? this.sendAuthAutoLoginAnalyticsEvent('fail') : null;
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
				this.setState({ errors, continueRegistration: true });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "createUserAuth() User Login Failed", error);
			errors["reason"] = this.props.intl.formatMessage(localeMessages.error_login_failed);
			this.setState({ errors, continueRegistration: true });
		}
	}

	async checkUserEmail() {
		let userClone = {...this.state.user};
		const { targetParams, fetchedGroup } = this.props;
		let errors = {};
		let updatedEmail = userClone.email;

		const isReelChatStudy = helpers.isReelChatStudy(targetParams);
		if (isReelChatStudy) {
			const username = updatedEmail.split("@")[0];
			updatedEmail = `${targetParams.gid}.${username}@reelchat-pilot.ly`;
		}

		this.setState({ 
			errors: {},
			buttonWaiting: true,
		});

		try {
			const result = await isEmailInUse({
				email: updatedEmail, 
				group: fetchedGroup, 
				test: TargetProcess.isTester(targetParams)
			});
			
			if (result) {
				Logger.log(this.constructor.name, "checkUserEmail() User Email Check Passed", result);
				userClone.email = updatedEmail;
				this.setState({ 
					errors: {}, 
					buttonWaiting: false,
					step: this.state.step + 1,
					user: userClone
				}, () => {
					setTimeout(() => {
						this.focusInput();
					}, 600);
				});

				return result;
			}
			else {
				Logger.log(this.constructor.name, "checkUserEmail() User Email Check Failed");
				errors["email"] = this.props.intl.formatMessage(localeMessages.error_email_check_failed);
				this.setState({
					errors: errors,
					buttonWaiting: false,
				});
			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "checkUserEmail() User Email Check Failed", error);

			if (error.code === "email_reserved") {
				errors["email"] = this.props.intl.formatMessage(localeMessages.error_email_in_use);
			}
			else if (error.code && (error.code.message === "email_validation" || error.code.message === "email_mismatch" || error.code.message === "email_undeliverable")) {
				errors["email"] = this.props.intl.formatMessage(localeMessages.error_email_invalid);
			}
			else {
				errors["email"] = this.props.intl.formatMessage(localeMessages.error_email_check_failed);
			}
			
			this.setState({
				errors: errors,
				buttonWaiting: false,
			});
		}
	}

	async checkUserZip() {
		let userClone = { ...this.state.user };
		let errors = {};
		try {
			const result = await getLocationByZipcode(userClone.zipcode);
			if (result) {
				Logger.log(this.constructor.name, "checkUserZip() Zip Code Check Passed", result);
				let newState = {
					errors: {},
					step: this.state.step + 1
				};
				if (result.REGION) {
					userClone.region = result.REGION;
					newState.user = userClone;
				}
				this.setState(newState, () => {
					setTimeout(() => {
						this.focusInput();
					}, 600);
				});
			}
			else {
				Logger.log(this.constructor.name, "checkUserZip() Zip Code Check Failed");
				errors["zipcode"] = this.props.intl.formatMessage(localeMessages.error_zip_check_failed);
				this.setState({ errors: errors });
			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "checkUserZip() Zip Code Check Failed", error);
			errors["zipcode"] = this.props.intl.formatMessage(localeMessages.error_zip_invalid);
			this.setState({ errors: errors });
		}
	}

	async loadDistributionList(dlist_id) {
		try {
			const result = await getDistributionList(dlist_id);

			if (result) {
				Logger.log(this.constructor.name, "loadDistributionList() Distrbution List: ", result);
				this.setState({fetchedDistributionList: result}, () => {
					this.props.setFetchedDistributionList(result);
				});
			}
			else {
				Logger.log(this.constructor.name, "loadDistributionList() Distrbution List Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "loadDistributionList() getDistributionList Failed", error);
			let errors = { ...this.state.errors };
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async setDistributionList(distList) {
		let targetParams = this.props.targetParams;
		let currentUser = this.props.currentUser;
		let verifiedEmails = distList.verifiedEmails && distList.verifiedEmails.length ? distList.verifiedEmails : [];
		if (targetParams.email) {
			for (let i = 0; i < verifiedEmails.length; i++) {
				let verifiedEmail = verifiedEmails[i];
				if(verifiedEmail.email === targetParams.email) {
					verifiedEmails[i].user_id = currentUser.user_id;
				}
			}
		}
		try {
			const result = await updateDistributionList(distList._id, verifiedEmails);
			Logger.log(this.constructor.name, "setDistributionList() updateDistributionList: ", result);
			if(result) {
				distList.verifiedEmails = verifiedEmails;
				this.setState({ fetchedDistributionList: distList }, () => {
					this.props.setFetchedDistributionList(distList);
				});
			}
		}
		catch (error) {
			Logger.log(this.constructor.name, "setDistributionList() updateDistributionList Failed", error);
			let errors = { ...this.state.errors };
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async loadEpisode(episode_id, user_token) {
		if(episode_id) {
			try {
				const result = await getEpisode(episode_id, user_token);
	
				if (result) {
					Logger.log(this.constructor.name, "loadEpisode() Episode: ", result);
					this.props.setFetchedEpisode(result);
				}
				else {
					Logger.log(this.constructor.name, "loadEpisode() Episode Failed: No result");
					let errors = { ...this.state.errors };
					errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
					this.setState({ errors });
				}
			}
			catch (error) {
				let errors = { ...this.state.errors };
				Logger.log(this.constructor.name, "loadEpisode() getEpisode() error", error);
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
	}

	async loadGroup(gid) {
		Logger.log(this.constructor.name, "loadGroup()", gid);
		try {
			const result = await getGroup(gid);

			if (result) {
				Logger.log(this.constructor.name, "loadGroup() getGroup result", result);
				this.setState({fetchedGroup: result}, () => {
					this.props.setFetchedGroup(result);
				});
			}
			else {
				this.setState({ loading: false });
				Logger.log(this.constructor.name, "loadGroup() No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadGroup() error", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async loadDeepGroup(group, panel_segment, user_token) {
		const gid = group._id.valueOf();

		try {
			let result = null;
			if (group.research_env === "svod" && helpers.isSVODPanelSegment(group, panel_segment)) {
				result = await getSVODGroup(gid, panel_segment, user_token);
			}
			else {
				result = await getDeepGroup(gid, panel_segment, user_token);
			}

			if (result) {
				Logger.log(this.constructor.name, "loadDeepGroup() Deep Group: ", result);
				await this.props.setFetchedGroup(result);

				// add function to subscribe to the group
				// Example /user/subscribe?user_token=' + token + '&video_id=' + video + '&group_id=' + group
				const isTester = TargetProcess.isTester(this.props.targetParams);
				let user = { ...this.state.user };
				let currentUser = this.props.currentUser ? { ...this.props.currentUser } : { ...user };
				let parentGuardian = { ...this.state.parentGuardian };
				let metadataFields = null;
				let isUpdatingViewerMetadata = helpers.checkUpdatingViewerMetadata(this.props.targetParams);

				if (isUpdatingViewerMetadata) {
					// if target params constent age then the type will always be a child.
					let metadataAge = parentGuardian.type === 'parent' && !this.props.targetParams.afc
						? (parentGuardian.age
							? parentGuardian.age
							: Math.round(moment().diff(parentGuardian.date_of_birth, 'years', true)))
						: (currentUser.age
							? currentUser.age
							: Math.round(moment().diff(currentUser.date_of_birth, 'years', true)));

					parentGuardian.age = metadataAge;
					metadataFields = { 
						type: this.props.targetParams.afc >= metadataAge ? 'child' : parentGuardian.type || 'viewer', 
						age: metadataAge, 
						parental_consent: parentGuardian.parental_consent,
					};

					if (this.props.targetParams.tc) metadataFields.terms_conditions = this.props.targetParams.tc === ACCEPT_TERMS_N_CONDITIONS;
				}

				if (metadataFields && !this.state.updatedViewerMetadata) {
					this.setState({ parentGuardian, updatedViewerMetadata: true }, () => {
						this.updateViewerMeta(user_token, this.props.currentUser, panel_segment, metadataFields);
					});
				}

				let screened = 0;
				let screenedIndex = null;
				let screenCode = "";
				if (!parentGuardian.parental_consent && 
					(this.props.targetParams.guidance || 
					(this.props.targetParams.afc && this.props.targetParams.afc >= currentUser.age))
				) {
					screened = 1;
					screenedIndex = this.props.targetParams.panelSegmentIndex || this.props.targetParams.ps;
					screenCode = FILTERED_REGISTRATION_CODE;
				}

				user.user_id = currentUser.user_id;
				user.ethnicity_enabled = helpers.isEthnicityFieldEnabled(this.props.targetParams);
				const userSubscribed = await this.setUserGroupSubscription(user_token, this.props.currentUser, result.video_id, gid, screened, screenedIndex, screenCode);

				const panel = await this.loadPanel(this.props.fetchedGroup, this.props.targetParams.panelSegmentIndex, user_token);
				if (panel) this.props.setFetchedPanel(panel);

				let registrationResponses = [];
				if (panel && !this.ethnicityResponseGenerated) {
					this.ethnicityResponseGenerated = true;
					registrationResponses = await createRegistrationResponses(this.props.fetchedGroup, panel, this.props.targetParams.panelSegmentIndex, user, user_token);
					Logger.log(this.constructor.name,'loadDeepGroup() HIDDEN REGISTRATION RESPONSES:', registrationResponses);
				}

				// Block the user from entering the study if he is in an invalid environment
				// based on the device enabled for the study
				const isValidEnvironment = this.validateEnvironment();
				if (!isValidEnvironment) {
					return;
				}

				if (!isTester && screened) {
					this.setState({ userEligible: !isTester && screened ? false : true });
				}
				else if (userSubscribed
					&& this.props.targetParams 
					&& this.props.targetParams.viewerConsent 
					&& !this.state.userAcceptedViewerConsentDisclaimer 
					&& this.props.targetParams.consentIndexes 
					&& (this.props.targetParams.consentIndexes.includes(this.props.targetParams.panelSegmentIndex)
					|| this.props.targetParams.consentIndexes.includes(parseInt(this.props.targetParams.panelSegmentIndex)))
				) {
					this.props.setTargetParams({ ...this.props.targetParams, userRegistered: true });
					this.props.history.push("/viewer-consent");
				}
				else if (userSubscribed
					&& this.props.targetParams 
					&& this.props.targetParams.videoDisclaimer 
					&& !this.state.userAcceptedVideoDisclaimer
				) {
					this.props.setTargetParams({ ...this.props.targetParams, userRegistered: true });
					this.props.history.push("/video-disclaimer");
				}
				else if (userSubscribed
					&& this.props.targetParams 
					&& this.props.targetParams.gid 
					&& this.props.targetParams.mpaa
				) {
					this.props.history.push("/mpaa");
				}
				else if (userSubscribed
					&& this.props.targetParams && this.props.targetParams.gid) {
					await enableFullscreen();
					this.props.history.push("/study");
				}
				else if (!userSubscribed) {
					const errors = { ...this.state.errors };
					errors["status"] = this.props.intl.formatMessage(localeMessages.error_register_failed);
					this.setState({ errors: errors, loading: false });
				}
			}
			else {
				Logger.log(this.constructor.name, "loadDeepGroup() Deep Group Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				// this.setState({ errors: errors, loading: false });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadDeepGroup() Deep Group Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			// this.setState({ errors: errors, loading: false });
		}
	}

	async loadPanel(group, psIndex, user_token, callback) {
		let panel_id;
		let survey_id;
		if (group
			&& group.panel_segment 
			&& group.panel_segment[psIndex] 
			&& (group.panel_segment[psIndex].survey_id || group.panel_segment[psIndex].panel)
		) {
			panel_id = group.panel_segment[psIndex].panel;
			survey_id = group.panel_segment[psIndex].survey_id;
		}

		try {
			if (panel_id || survey_id) {
				const result = await getStudyPanel(panel_id, survey_id, user_token);
				
				if (result) {
					Logger.log(this.constructor.name, "loadPanel() result:", result);
					this.setState({ panel: result }, () => {
						if (callback) callback();
					});

					return result;
				}
				else {
					Logger.log(this.constructor.name, "loadPanel() No result");
					let errors = { ...this.state.errors };
					errors["panel"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
					this.setState({ errors });
				}
			}
		}
		catch(error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadPanel() error", error);
			errors["panel"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async setUserGroupSubscription(user_token, currentUser, video_id, group_id, screened, screenedIndex, screen_code) {
		const { user } = this.state;
		let subscribeFn = this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl) ? groupJoinSubscription : groupSubscribe;
		const isTester = TargetProcess.isTester(this.props.targetParams);

		Logger.log(this.constructor.name, "setUserGroupSubscription() suscribe, tester", currentUser, video_id, group_id, screened, screenedIndex, screen_code, (this.props.targetParams && (this.props.targetParams.partner || this.props.targetParams.dl)), isTester, this.props.targetParams);

		try {
			let panelSegment = this.state.fetchedGroupPanelSegment ? {...this.state.fetchedGroupPanelSegment} : {};
			let panelSegmentIndex = panelSegment.index || panelSegment.index === 0 ? 
				panelSegment.index 
				: 
				// ISTESTER why forcing tester through?
				// diff between targetParams.ps and targetParams.panelSegmentIndex?
				(screened && (screenedIndex || screenedIndex === 0) ? screenedIndex : (isTester ? this.props.targetParams.ps || this.props.targetParams.panelSegmentIndex : null));
			const userLanguageCode = user.language;
			const userId = currentUser.user_id;
			const browser = DeviceHelper.browser;
			const device = DeviceHelper.device;
			const result = await subscribeFn(user_token, userId, video_id, group_id, panelSegmentIndex, userLanguageCode, screened, screen_code, isTester, true, browser, device);

			if (result) {
				Logger.log(this.constructor.name, "setUserGroupSubscription() Group: ", result);
				this.setState({ subscribed: true });
			}
			else {
				Logger.log(this.constructor.name, "setUserGroupSubscription() Group Subscription Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				// this.setState({ errors: errors, loading: false });
			}

			return result;
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "setUserGroupSubscription() Group Subscription Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			// this.setState({ errors: errors, loading: false });
			return null;
		}
	}

	async loadGroupPanelSegment(gid, hhi, age, gender, device, region, provider, user_token) {
		Logger.log(this.constructor.name, "loadGroupPanelSegment()", gid, hhi, age, gender, device, region, provider, user_token);

		let targetParams = { ...this.props.targetParams };
		const { hispanic, race, ethnicity_recode } = this.props.currentUser.user_demographic;
		const ethnicityParams = {
			hispanic,
			race,
			ethnicity_recode
		};

		try {
			let panelSegmentIndex = targetParams && (targetParams.ps || targetParams.ps === 0) ? parseInt(targetParams.ps) : null;

			const isTester = TargetProcess.isTester(targetParams);
			const isPanelSegmentRequired = isNumber(targetParams.psreq) && Number(targetParams.psreq) === 1 ? 1 : 0;
			const result = await getGroupPanelSegment(gid, hhi, age, gender, device, region, provider, ethnicityParams, user_token, panelSegmentIndex, isTester, isPanelSegmentRequired);

			if (result) {
				Logger.log(this.constructor.name, "loadGroupPanelSegment() Panel Segment: ", result);
				let psIndex = isTester ? 
					(panelSegmentIndex ? panelSegmentIndex : "0")
					:
					result.index;

				Object.assign(targetParams, { panelSegmentIndex: psIndex, ps: psIndex });
				await this.props.setTargetParams(targetParams);
				this.setState({ fetchedGroupPanelSegment: result }, async () => {
					const testerBypass = isTester && !result.active;

					// screens out the user
					if (!result.found && !testerBypass) {
						Logger.log(this.constructor.name, "loadGroupPanelSegment(): Update user subscription to screened", result);
						let video_id = this.props.fetchedGroup && this.props.fetchedGroup.video_id ? this.props.fetchedGroup.video_id : "";
						// let user_id = this.props.currentUser && this.props.currentUser.user_id ? this.props.currentUser.user_id : "";
						let screened = 1;
						let screenedIndex = targetParams && targetParams.ps ? targetParams.ps : (result.target ? result.target : 0);
						let screenCode = helpers.getPanelSegmentScreenCode(result);
						await this.setUserGroupSubscription(user_token, this.props.currentUser, video_id, gid, screened, screenedIndex, screenCode);

						// if (isTester) this.validateUserEligiblity();
					}
					else if (result.aidMethods) {
						setPlayerSessionQuotaMethods(result.aidMethods);
					}

					let studyRedirects = helpers.returnStudyRedirects(this.props.fetchedGroup, result.index);
					if (studyRedirects
						&& result.found
						&& result.index != targetParams.ps
					) {
						Object.assign(targetParams, studyRedirects);
						targetParams = helpers.setupRedirectsFromParams(targetParams);
						this.props.setTargetParams(targetParams);
					}

					this.validateUserEligiblity();
				});
			}
			else {
				Logger.log(this.constructor.name, "loadGroupPanelSegment() Panel Segment Failed: No result");
				let errors = { ...this.state.errors };
				errors["reason"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadGroupPanelSegment() Panel Segment Failed", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async validateAuthedUser() {
		Logger.log(this.constructor.name, "validateAuthedUser()");
		const { targetParams, currentUser: authedUser } = this.props;
		const { user: stateUser } = this.state;
		const stateUserAge = Math.round(moment().diff(stateUser.date_of_birth, 'years', true));
		// const isTester = TargetProcess.isTester(this.props.targetParams);

		if (targetParams && targetParams.partner && targetParams.partner === "GMI" && targetParams.fakeUser) {
			await this.createUserAuth(targetParams.fakeUser.email, targetParams.fakeUser.password);
			await this.validateUserEligiblity();
			return;
		}

		if (targetParams && targetParams.partner) {
			await this.validateUserEligiblity();
			return;
		}
		/*
			firstname, lastname, gender, age, hhi, ethnicity, education
		*/
		let isUserValid = false;
		if (authedUser.firstname === stateUser.firstname &&
			authedUser.lastname === stateUser.lastname &&
			authedUser.user_demographic.gender === stateUser.gender &&
			authedUser.user_demographic.age === stateUserAge &&
			(!stateUser.ethnicity.toString() || authedUser.user_demographic.ethnicity === stateUser.ethnicity.toString()) &&
			(!stateUser.education || authedUser.user_demographic.education === stateUser.education)) {
			isUserValid = true;
		}

		let screenedUser = this.isUserScreened();

		if (isUserValid && !screenedUser) {
			await this.validateUserEligiblity();
		}
		else {
			this.setState({ userEligible: false });
		}
	}

	// sets state instead of returning an object
	async validateUserEligiblity() {
		Logger.log(this.constructor.name, "validateUserEligiblity()", this.props, this.state.user);

		const { parentGuardian, fetchedGroupPanelSegment } = this.state;
		const { targetParams } = this.props;
		const user = this.props.currentUser || this.state.user;
		const userAge = user.age || Math.round(moment().diff(user.dob || user.date_of_birth, 'years', true));
		
		if (user &&
			userAge &&
			helpers.isAgeRestricted(targetParams, user.age) && 
			(!targetParams.guidance || (targetParams.guidance && !parentGuardian.parental_consent)) &&
			(!targetParams.afc || (targetParams.afc && !parentGuardian.parental_consent))
		) {
			this.setState({ userEligible: false });
		}
		else if (targetParams && !fetchedGroupPanelSegment) {
			const userHHI = (user.user_demographic && user.user_demographic.hhi) || user.household_income;
			const user_token = auth.getToken();
			const device = "pc";

			const provider = targetParams && targetParams.provider
				? targetParams.provider
				: null;
			await this.loadGroupPanelSegment(targetParams.gid, userHHI, userAge, user.gender, device, user.region, provider, user_token);
		}
		else if (targetParams && fetchedGroupPanelSegment && !fetchedGroupPanelSegment.studyReady) {
			this.setState({ studyReady: false });
		}
		else {
			this.displayNextSteps();
		}
	}

	// function is triggered after registration is complete. This will either render a feedback message or redirect to the study or provider link
	async displayNextSteps() {
		Logger.log(this.constructor.name, "displayNextSteps()");
		const { fetchedGroupPanelSegment: panelSegment } = this.state;
		const { targetParams } = this.props;
		const isTester = TargetProcess.isTester(targetParams);
		const isScreenedUser = this.isUserScreened();

		if ((!isScreenedUser || isTester)
			&& targetParams
			&& targetParams.gid
			&& panelSegment
			&& (panelSegment.found || (isTester && (panelSegment.fitsFilter || panelSegment.quotaFiltered)))
		) {
			const psIndex = panelSegment.index || panelSegment.index === 0
				? panelSegment.index
				: (isTester && (panelSegment.target || panelSegment.target === 0)) ? panelSegment.target : 0;

			let user_token = auth.getToken();
			let episode_id = this.props.fetchedGroup.panel_segment && this.props.fetchedGroup.panel_segment[psIndex] ? this.props.fetchedGroup.panel_segment[psIndex].episode : "";

			await this.loadEpisode(episode_id, user_token);
			await this.loadDeepGroup(this.props.fetchedGroup, psIndex, user_token);

			if (targetParams.question_tid && targetParams.answer_index) {
				const poll_ids = this.props.fetchedGroup
					&& this.props.fetchedGroup.panel_segment
					&& this.props.fetchedGroup.panel_segment[psIndex]
					&& this.props.fetchedGroup.panel_segment[psIndex].poll_ids;
				submitPollResponseWithQuestionTid(targetParams, user_token, poll_ids);
			}

			if (targetParams.dl) this.setDistributionList(this.props.fetchedDistributionList);
		}
		else if (!targetParams || !targetParams.gid) {
			this.props.history.push("/home");
		}
		else if (isScreenedUser || !panelSegment || !panelSegment.active || !panelSegment.found) {
			this.setState({ userEligible: false });
		}
		else {
			Logger.warn(this.constructor.name, "displayNextSteps() unexpected default clause", isScreenedUser, isTester, targetParams, panelSegment);
		}
	}

	/***** input pattern handlers *****/
	handleHouseholdIncomeKeyDown(e) {
		// avoid writing math symbols in the input
		const notAllowedInputs = ['.', ',', '+', '-', 'e', 'E'];

		if (notAllowedInputs.includes(e.key)) e.preventDefault();
	}

	handleHouseholdIncomePaste(e) {
		e.stopPropagation();
		e.preventDefault();

		// get the value on user's clipboard
		const clipboardData = e.clipboardData || window.clipboardData;
		let pastedText = clipboardData.getData('Text').trim();

		const hasDot = pastedText.includes('.');
		const hasComma = pastedText.includes(',');

		pastedText = pastedText.replace(',', '.');

		let values = pastedText.split('.');
		const lastValue = values.pop();

		let result;
		if (!values.length) {
			result = lastValue;
		} else if (lastValue.length !== 3 || (hasDot && hasComma)) {
			result = values.join('');
		} else {
			result = [...values, lastValue].join('');
		}

		// avoid pasting non numeric values
		result = result.replace(/[^0-9]*/g,'');

		const userClone = { ...this.state.user };
		userClone.household_income = result;

		this.setState({ user: userClone });
	}

	/***** validators *****/
	validateText(key, isBtnTrigger, event) {
		let userClone = {...this.state.user};
		let parentGuardian = { ...this.state.parentGuardian };
		let errors = {};
		
		if (!userClone[key] && (event.keyCode === 13 || isBtnTrigger)) {
			let name = key.replace('_', ' ');
			name = (parentGuardian.type === "parent" && key === "age" ? "child's " : " ") + name;
			key = (parentGuardian.type === "parent" && key === "age" ? "child_" : "") + key;
			errors[key] = this.props.intl.formatMessage(localeMessages.error_name, { name: name });
		}
		return Object.keys(errors).length ? errors : false;
	}

	validateName(isBtnTrigger, event) {
		let userClone = {...this.state.user};
		let errors    = {};
		let fullname  = userClone.fullname;
		let namecomps = fullname.split(' ');

		let firstname = "";
		let middlename= "";
		let lastname  = "";

		if (fullname.length < 5 ||
			namecomps.length > 4 || 
			fullname.search(/[#\%0-9\&\*\(\)@?!]/g) !== -1 || 
			fullname.search(/\-/g) === 0 || 
			(fullname.split('.').length - 1) > 1 || 
			fullname.search(' ') === -1 || 
			(fullname.indexOf('John') === 0 && fullname.indexOf('Doe') > 0)){

			errors["fullname"] = this.props.intl.formatMessage(localeMessages.error_full_name);

			// this.setState({errors: errors});
			//userClone.fullname = '';  //SHOULDNT THIS HAPPEN ?
			//userClone.firstname = "";
			//userClone.lastname  = "";

		} else {
			firstname = namecomps[0];

			if(namecomps.length === 2){
				lastname  = namecomps[1];
			} else {
				middlename = namecomps[1];
				lastname   = (namecomps[2].replace('.','').toLowerCase() === 'jr' || namecomps[2].replace('.','').toLowerCase() === 'sr') ? namecomps[1] : namecomps[2];
			}

			if (lastname < 2 || (middlename && middlename < 2) || firstname < 3){
				errors["fullname"] = this.props.intl.formatMessage(localeMessages.error_full_name);
				// this.setState({errors: errors});
				//userClone.fullname  = "";
				//userClone.firstname = "";
				//userClone.lastname  = "";
				
			} else {
				// userClone.fullname  = name;
				userClone.firstname = firstname;
				userClone.lastname  = lastname;
				this.setState({ user: userClone });
			}
		}
		return Object.keys(errors).length ? errors : false;
	}

	validateZip(key, isBtnTrigger, event) {
		var userClone = { ...this.state.user };
		var errors = {};
		var nonDigitRegex = /\D/;
		var zipcodeString = userClone[key] ? userClone[key].toString() : null;
		if ((!zipcodeString || nonDigitRegex.test(zipcodeString) || zipcodeString.length !== 5 || isNaN(userClone[key])) && (event.keyCode === 13 || isBtnTrigger)) {
			var zipcode = key.replace('_', ' ');
			errors[key] = this.props.intl.formatMessage(localeMessages.error_zipcode, { zipcode: zipcode });
		}
		return Object.keys(errors).length ? errors : false;
	}

	validateIncome(isBtnTrigger, event) {
		let userClone = { ...this.state.user };
		let errors = {};
		let income = userClone.household_income;

		const isIntl = userClone.isInternationalUser;
		if (event.keyCode === 13 || isBtnTrigger) {
			if (!income || isNaN(income) || income.split(".").length > 1 || income < 1 || (isIntl && income > 10000000000) || (!isIntl && income > 10000000)) {
				errors['household_income'] = this.props.intl.formatMessage(localeMessages.error_income);
				// this.setState({errors: errors});
			}
			else {
				userClone.household_income = income;
				this.setState({ user: userClone });
			}
		}
		return Object.keys(errors).length ? errors : false;
	}

	validateDOB(isBtnTrigger, event, isParent) {
		let user = {...this.state.user};
		let parentGuardian = { ...this.state.parentGuardian };
		let userClone = isParent ? parentGuardian : user;

		let targetParams = {...this.props.targetParams};
		let errors = {};
		let dob = userClone.date_of_birth ? userClone.date_of_birth.split('/') : userClone.date_of_birth;
		let age = userClone.age ? userClone.age : Math.round(moment().diff(userClone.date_of_birth, 'years', true));
		let errorMessage = null;

		let componentError = false;
		let currentDate = new Date();
		let earliestDOBYear = currentDate.getFullYear() - MAX_AGE_RESTRICTION;
		let latestDOBYear = currentDate.getFullYear() - MIN_AGE_RESTRICTION;

		if(event.keyCode === 13 || isBtnTrigger) {
			if(!dob || dob.length !== 3){
				componentError = true;
			}

			let twoDigitPattern  =/([0-9]{2})/;
			let fourDigitPattern =/([0-9]{4})/;

			if(!twoDigitPattern.test(dob[0]) || dob[0] > 12 || dob[0] < 1 ||  dob[0].search(/./g) >0){
				componentError = true;
			} 

			if(!twoDigitPattern.test(dob[1]) || dob[1] > 31 || dob[1] < 1 || dob[1].search(/./g) >0){
				componentError = true;
			}

			if(!fourDigitPattern.test(dob[2]) || Number(dob[2]) < earliestDOBYear || Number(dob[2]) > latestDOBYear  || dob[2].search(/./g) > 0){
				componentError = true;
			} 

			if (componentError ||
				(helpers.isAgeRestricted(targetParams, age) &&
					!targetParams.partner &&
					!targetParams.dl &&
					!targetParams.guidance &&
					!targetParams.afc)
			) {
				errorMessage = this.props.intl.formatMessage(localeMessages.error_birth_date);
				errors['date_of_birth'] = errorMessage;
			}

		}
		return Object.keys(errors).length ? errors : false;
	}

	validateParentAge(key, isBtnTrigger, event) {
		let parentGuardian = { ...this.state.parentGuardian };
		let errors = {};
		if (!parentGuardian[key] && (event.keyCode === 13 || isBtnTrigger)) {
			let name = key.replace('_', ' ');
			errors[key] = this.props.intl.formatMessage(localeMessages.error_name, { name: name });
		}
		return Object.keys(errors).length ? errors : false;
	}

	validateParticipantAge(isBtnTrigger, event) {
		let userClone = {...this.state.user};
		let errors = {};
		if (!isValidAge(userClone.age) && (event.keyCode === 13 || isBtnTrigger)) {
			errors['age'] = this.props.intl.formatMessage(localeMessages.error_age);
		}
		return Object.keys(errors).length ? errors : false;
	}

	validateEmail(isBtnTrigger, event) {
		let userClone = {...this.state.user};
		let errors = {};
		
		if(event.keyCode === 13 || isBtnTrigger) {
			const domainPattern = /@[A-Za-z0-9.-]+\./;
			const domainMatch = userClone.email ? userClone.email.match(domainPattern) : null;
			const domain = domainMatch ? domainMatch[0] : null;

			if (!userClone.email) {
				errors['email'] = this.props.intl.formatMessage(localeMessages.error_email_missing);
			} 
			else if (!auth.isValidEmail(userClone.email)) {
				errors['email'] = this.props.intl.formatMessage(localeMessages.error_email_invalid);
			}
			else if (domain && domain.length < 4) {
				errors['email'] = this.props.intl.formatMessage(localeMessages.error_email_invalid_domain);
			}
		}
		return Object.keys(errors).length ? errors : false;
	}

	validateEthnicity(isBtnTrigger, event) {
		let userClone = {...this.state.user};
		let errors = {};

		if(!userClone.ethnicity_race || !userClone.ethnicity_race.length) {
			errors['ethnicity_race'] = this.props.intl.formatMessage(localeMessages.error_ethnicity_missing);
		}
		return Object.keys(errors).length ? errors : false;
	}

	validatePassword(isBtnTrigger, event) {
		let userClone = { ...this.state.user };
		let errors = {};

		if (event.keyCode === 13 || isBtnTrigger) {
			const validPasswordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!$%@#£€*?&]{8,}$/;
			if (!userClone.password) {
				errors['password'] = this.props.intl.formatMessage(localeMessages.error_password_missing);

			} else if (!validPasswordPattern.test(userClone.password)) {
				errors['password'] = this.props.intl.formatMessage(localeMessages.error_password_invalid);
			}
		}
		return Object.keys(errors).length ? errors : false;
	}

	isUserScreened() {
		Logger.log(this.constructor.name, "isUserScreened()");
		let authedUser = { ...this.props.currentUser };
		if (authedUser.subscriptions && authedUser.subscriptions.list && authedUser.subscriptions.list.length &&
			this.props.fetchedGroup && this.props.fetchedGroup._id) {
			for (let i = 0; i < authedUser.subscriptions.list.length; i++) {
				let groupSubscription = authedUser.subscriptions.list[i];
				if (groupSubscription.group_id === this.props.fetchedGroup._id && groupSubscription.screened) {
					return true;
				}
			}
		}
		
		if (authedUser.subscriptions && authedUser.subscriptions.group && authedUser.subscriptions.group.length &&
			this.props.fetchedGroup && this.props.fetchedGroup._id) {
			for (let i = 0; i < authedUser.subscriptions.group.length; i++) {
				let groupSubscription = authedUser.subscriptions.group[i];
				if (groupSubscription.group_id === this.props.fetchedGroup._id && groupSubscription.screened) {
					return true;
				}
			}
		}
		return false;
	}

	isUserSubscribed(currentUser, group_id, subscribed) {
		Logger.log(this.constructor.name, "isUserSubscribed()");
		// checking subscriptions.list. This is a list of groups a user is subscribed to
		// subscriptions.group is a list of groups a user is eligibile to watch
		if (currentUser.subscriptions && currentUser.subscriptions.list && currentUser.subscriptions.list.length && group_id && !subscribed) {
			for (let i = 0; i < currentUser.subscriptions.list.length; i++) {
				let groupSubscription = currentUser.subscriptions.list[i];
				if (groupSubscription.group_id === group_id) {
					return true;
				}
			}
		}
		return false;
	}
	
	/***** state handlers *****/
	handleChange(event, isParent) {
		let key = event.target.name;
		let value = event.target.value;
		let parentGuardian = {...this.state.parentGuardian};
		let userClone = {...this.state.user};

		if (isParent && key === "age") {
			parentGuardian[key] = value;
		}
		else {
			userClone[key] = value;
		}
		this.setState({ user: userClone, parentGuardian: parentGuardian });
	}

	handleDateChange(event, isParent) {
		let value = event.target.value;
		let currentValue = this._dateOfBirth.current.defaultValue;

		let userClone = {...this.state.user};
		let parentGuardian = {...this.state.parentGuardian};
		let numChars = value.length;
		let keyPress = value[numChars-1];
		let updatedValue = value;

		let differenceText = Register.getStringDifference(value, currentValue);
		
		if(keyPress !== '/' && differenceText !== '/') { 
			if(numChars === 2 || numChars === 5){
				updatedValue += '/';
			}

		} else {
			if(numChars === 2 || numChars === 5) {
				updatedValue = value.substr(0,numChars-1);
			}
		}

		if(updatedValue.indexOf('//') !== -1){
			updatedValue = updatedValue.replace('//','/');
		}

		if (isParent) {
			parentGuardian['date_of_birth'] = updatedValue;
		}
		else {
			userClone['date_of_birth'] = updatedValue;
		}
		this.setState({ user: userClone, parentGuardian });
	}

	handleParentGuardian(type) {
		let parentGuardian = { ...this.state.parentGuardian };
		parentGuardian['type'] = type;

		switch(type) {
			case "parent": {
				parentGuardian.parental_consent = true;
				break;
			}
			case "child": {
				parentGuardian.parental_consent = false;
				break;
			}
		}
		this.setState({ parentGuardian: parentGuardian, step: this.state.step + 1, errors: {} }, () => {
			setTimeout(() => {
				this.focusInput();
			}, 600);
		});
	}

	handleGenderChange(gender) {
		let userClone = {...this.state.user};
		userClone['gender'] = gender;
		this.setState({ user: userClone, step: this.state.step + 1, errors: {}}, () => {
			setTimeout(() => {
				this.focusInput();
			}, 600);
		});
	}

	handleHispanicSubmit(isHispanicBool) {
		let userClone = { ...this.state.user };
		userClone['ethnicity_hispanic'] = isHispanicBool;
		this.setState({ user: userClone, step: this.state.step + 1, errors: {} }, () => {
			setTimeout(() => {
				this.focusInput();
			}, 600);
		});
	}

	handleParentalConsent(constentBool) {
		let parentGuardian = { ...this.state.parentGuardian };
		parentGuardian['parental_consent'] = constentBool;
		this.setState({ parentGuardian: parentGuardian, step: this.state.step + 1, errors: {} }, () => {
			setTimeout(() => {
				this.focusInput();
			}, 600);
		});
	}
	
	handleCountrySelect(event) {
		let userClone = { ...this.state.user };
		let isInternationalUser = this.state.isInternationalUser;
		let value = event.target.value;
		userClone['country'] = value;

		if (value !== 'US') {
			isInternationalUser = true;
			userClone.isInternationalUser = true;
			userClone.zipcode = 'INTL';
		}
		else {
			isInternationalUser = false;
			userClone.isInternationalUser = false;
			userClone.zipcode = userClone.zipcode && userClone.zipcode !== 'INTL' ? userClone.zipcode : '';
		}

		this.setState({ 
			user: userClone, 
			isInternationalUser: isInternationalUser, 
			errors: {} 
		});
	}

	handleEthnicitySelect(event) {
		let userClone = {...this.state.user};
		let ethnicities = [];
		if(event.target.selectedOptions && event.target.selectedOptions.length) {
			for(let i = 0; i < event.target.selectedOptions.length; i++) {
				let option = event.target.selectedOptions[i];
				ethnicities.push(option.value);
			}
		}
		userClone['ethnicity_race'] = ethnicities;
		this.setState({user: userClone, errors: {}});
	}

	handleEducationSelect(event) {
		let userClone = {...this.state.user};
		let value = event.target.value;
		userClone['education'] = value;
		this.setState({user: userClone, step: this.state.step + 1, errors: {}});
	}

	handleNext(currentField, isBtnTrigger, event, isParent) {
		let errors = {};
		let wait = false;
		switch(currentField) {
			case "parental_consent": case "gender": case "education": case "country": {
				if (currentField === "parental_consent") {
					errors = null;
				}
				else {
					errors = this.validateText(currentField, isBtnTrigger, event);
				}
				break;
			}
			case "fullname":{
				errors = this.validateName(isBtnTrigger, event);
				break;
			}
			case "zipcode":{
				errors = this.validateZip(currentField, isBtnTrigger, event);
				if (!errors && (event.keyCode === 13 || isBtnTrigger)) {
					wait = true;
					errors = this.checkUserZip();
				}
				break;
			}
			case "age": {
				if (isParent) {
					errors = this.validateParentAge(currentField, isBtnTrigger, event);
				} else {
					errors = this.validateParticipantAge(isBtnTrigger, event);
				}
				break;
			}
			case "date_of_birth": {
				errors = this.validateDOB(isBtnTrigger, event, isParent);
				break;
			}
			case "email": {
				errors = this.validateEmail(isBtnTrigger, event);
				if(!errors && (event.keyCode === 13 || isBtnTrigger)) {
					wait = true;
					this.checkUserEmail().then(result => {
						Logger.log(this.constructor.name, "handleNext() checkUserEmail() result", result);
						if (result && result.email_obfuscated) {
							this.setState({
								email_obfuscated: result.email_obfuscated
							});
						}
					})
						.catch((error) => {
							Logger.error(this.constructor.name, "handleNext() checkUserEmail() error", error);
							this.setState({ messages: {}, errors, loading: false });
						});
				}
				break;
			}
			case "household_income":{
				errors = this.validateIncome(isBtnTrigger, event);
				break;
			}
			case "ethnicity_hispanic": {
				errors = null;
				break;
			}
			case "ethnicity_race":{
				errors = this.validateEthnicity(isBtnTrigger, event);
				break;
			}
			case "password":{
				errors = this.validatePassword(currentField, isBtnTrigger, event);
				break;
			}
		}

		if ((!wait && !errors && event && event.keyCode === 13) || (!wait && !errors && isBtnTrigger)) {
			this.setState({ errors: {}, step: this.state.step + 1 }, () => { 
				setTimeout(() => {
					this.focusInput();
				}, 600);
			});
		} 
		else if ((!wait && errors && event && event.keyCode === 13) || (!wait && errors && isBtnTrigger)) {
			this.setState({errors: errors});
		}
	}

	handlePrevious() {
		console.log('handlePrevious');
		if (this.state.step) {
			this.setState({ step: this.state.step - 1 }, () => {
				setTimeout(() => {
					this.focusInput();
				}, 600);
			});
		}
	}

	/***** get functions *****/
	getPartnerClass(targetParams) {
		let partnerClass = '';
		if (targetParams && targetParams.partner) {
			switch (targetParams.partner) {
				case 'alida': {
					const mobileClass = DeviceHelper.isMobile ? "alida-mobile" : "";
					partnerClass = this.state.displayRegistration ? '' : `${mobileClass} alida-ready-to-begin ghost-bkgd`;
					break;
				}
				case 'qualtrics': {
					const mobileClass = DeviceHelper.isMobile ? "qualtrics-mobile" : "";
					partnerClass = this.state.displayRegistration ? '' : `${mobileClass} qualtrics-ready-to-begin white-bkgd`;
					break;
				}
			}
		}

		return partnerClass;
	}

	getInputFieldClass(step) {
		if(step === this.state.step) {
			return " show";
		}
		if(this.state.step - step === 1) {
			return " previous";
		}
		if(this.state.step - step > 1) {
			return " hide";
		}   
		return "";
	}

	getViewerMetadata(currentUser, group) {
		if (group && 
			group._id &&
			currentUser && 
			currentUser.viewer_metadata && 
			currentUser.viewer_metadata.length
		) {
			for (let i = 0; i < currentUser.viewer_metadata.length; i++) {
				let metadata = currentUser.viewer_metadata[i];
				if (metadata.user_id === currentUser.user_id &&
					metadata.group_id.valueOf() === group._id.valueOf()
				) {
					return metadata;
				}
			}
		}
		return null;
	}

	getGroupPoster(group) {
		let artwork = group && group.artwork && group.artwork[0] ? group && group.artwork && group.artwork[0] : null; 
		let poster = artwork ? (artwork.poster ? artwork.poster : (artwork.background ? artwork.background : null)) : null;
		return poster;
	}

	getUserFeedbackDisplay() {

		// if distribution list available check for if the email being used is in the list
		let feedbackType = null;
		let study = this.state.fetchedGroup ? { ...this.state.fetchedGroup } : null;
		let panelSegment = this.state.fetchedGroupPanelSegment ? {...this.state.fetchedGroupPanelSegment} : null;
		let errors = {...this.state.errors};
		let parentGuardian = { ...this.state.parentGuardian };
		
		const { targetParams, globalAnalyticsAdapter } = this.props;
		const isPartner = targetParams && targetParams.partner;
		const isDistList = targetParams && targetParams.dl;
		const isTester = TargetProcess.isTester(targetParams);
		let sessionStatus = {};

		if (errors.status) return "error";

		if (!targetParams) return null;

		if (study) {
			if (study.availability) {
				if (study.availability === "notfound") {
					feedbackType = study.availability;
				}
				else if (study.availability !== "active" && !isTester) {
					feedbackType = study.availability;
				}
			}

			// temporary feedback display for non web studies ('invalidgroup')
			feedbackType = study.research_env !== "inVideo" && study.research_env !== "svod" && study.research_env !== "survey"
				? "notfound"
				: feedbackType;
		}

		if (targetParams && targetParams.nf) {
			// temporary feedback display for nativefeed study ('invalidgroup')
			feedbackType = "notfound";
		}

		if (!feedbackType
			&& targetParams
			&& targetParams.dl
			&& targetParams.email
			&& this.props.fetchedDistributionList
		) {
			let emailFound = false;
			for(let i = 0; i < this.props.fetchedDistributionList.verifiedEmails.length; i++) {
				let verifiedViewer = this.props.fetchedDistributionList.verifiedEmails[i];
				if (verifiedViewer.email === targetParams.email || (targetParams.email.includes(PILOTLY_TESTER_USER) && isTester)) {
					emailFound = true;
					break;
				}
			}
			if (!emailFound) feedbackType = "invalidemail";
		}
		
		if (!feedbackType && panelSegment && !panelSegment.active && !isTester) {
			feedbackType = "studyclosed";
		}
		else if (!feedbackType && panelSegment && !panelSegment.found && (panelSegment.quotaFull || !panelSegment.fitsQuota) && !isTester) {
			feedbackType = "overquota";
		}
		else if (!feedbackType && panelSegment && !panelSegment.found && (!panelSegment.fitsFilter || panelSegment.quotaFiltered || !panelSegment.eligible) && !isTester) {
			feedbackType = "ineligible";
		}
		else if (!feedbackType && panelSegment && !panelSegment.found && !isTester) {
			feedbackType = "notfound";
		}
		else if (!feedbackType && panelSegment && !panelSegment.studyReady && !isTester) {
			feedbackType = "studynotstarted";
		}

		if(!feedbackType && !this.state.userEligible) {
			feedbackType = "ineligible";
			const RENDER_FEEDBACK_DISPLAY = SessionStatusEvent.RENDER_FEEDBACK_DISPLAY.replace("[type]", 'UserScreened');

			sessionStatus = new SessionStatus(RENDER_FEEDBACK_DISPLAY, '', '', false, false, true);
			sessionStatus.gaTracker = this.props.tracker;
			sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
			sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
			globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
		}

		if (!feedbackType &&
			this.props.currentUser &&
			helpers.isAgeRestricted(targetParams, this.props.currentUser.age) &&
			(!targetParams.guidance || (targetParams.guidance && !parentGuardian.parental_consent)) &&
			(!targetParams.afc || (targetParams.afc && !parentGuardian.parental_consent))
		) {
			feedbackType = "ineligible";
		}

		if (!feedbackType && this.state.userStudyStatus === "completed" && !isTester) {
			feedbackType = "alreadycompleted";
			const RENDER_FEEDBACK_DISPLAY = SessionStatusEvent.RENDER_FEEDBACK_DISPLAY.replace("[type]", 'UserCompleted');

			sessionStatus = new SessionStatus(RENDER_FEEDBACK_DISPLAY, '', '', false, false, true);
			sessionStatus.gaTracker = this.props.tracker;
			sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
			sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
			globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);
		}
		
		if (!feedbackType && (this.state.userStudyStatus === 'screened' || this.state.userStudyStatus === 'completed')) {
			feedbackType = "studyreentry";
		}

		if (!feedbackType && (this.state.userStudyStatus === 'thankyou' || this.state.userStudyStatus === 'terminate')) {
			feedbackType = this.state.userStudyStatus;
		}

		if (!feedbackType && !this.state.isValidEnvironment) {
			feedbackType = 'invalid_environment';
		}

		Logger.log(this.constructor.name, "getUserFeedbackDisplay()", feedbackType, isTester, targetParams, panelSegment, this.props, this.state);

		return feedbackType;
	}

	getWelcomeDisplay(targetParams, fetchedGroup) {
		Logger.log(this.constructor.name, "getWelcomeDisplay()", targetParams, fetchedGroup);

		let welcome = {title: "", message: "", registerTitle: "", registerSubText: "", ctaButton: ""};

		welcome.title = this.props.intl.formatMessage(localeMessages.title);

		if (fetchedGroup) {
			const group_name = fetchedGroup.study_name || fetchedGroup.title;

			if (targetParams && targetParams.partner) {
				let ctaButtonText = targetParams.partner === 'alida' || targetParams.partner === 'qualtrics'
					? localeMessages.button_next
					: localeMessages.button_begin_study;
				const message = targetParams.partner === 'qualtrics' ? localeMessages.qualtrics_message : localeMessages.message;
				const verifyMessage = targetParams.partner === 'qualtrics' ? "" : " " + this.props.intl.formatMessage(localeMessages.verify);

				welcome.title = targetParams.partner === 'qualtrics' ? this.props.intl.formatMessage(localeMessages.qualtrics_title) : welcome.title;
				welcome.message = this.props.intl.formatMessage(message, { group_name: group_name }) + verifyMessage;
				welcome.registerTitle = targetParams.partner === 'qualtrics' ? localeMessages.qualtrics_welcome_to_study : this.props.intl.formatMessage(localeMessages.welcome_to_study);
				welcome.registerSubText = this.props.intl.formatMessage(localeMessages.eligible);
				welcome.ctaButton = this.props.intl.formatMessage(ctaButtonText);

			} else if (targetParams && targetParams.dl) {
				welcome.message = this.props.intl.formatMessage(localeMessages.message, { group_name: group_name }) + " " + this.props.intl.formatMessage(localeMessages.verify);
				welcome.registerTitle = this.props.intl.formatMessage(localeMessages.welcome_to_study);
				welcome.registerSubText = this.props.intl.formatMessage(localeMessages.eligible);
				welcome.ctaButton = this.props.intl.formatMessage(localeMessages.button_begin_screening);

			} else if (targetParams && !targetParams.fakeUser) {
				welcome.registerTitle = this.props.intl.formatMessage(localeMessages.welcome_to_study);
				welcome.message = welcome.message = this.props.intl.formatMessage(localeMessages.message, { group_name: group_name });
				welcome.ctaButton = this.props.intl.formatMessage(localeMessages.button_begin_screening);

			} else {
				welcome.registerTitle = this.props.intl.formatMessage(localeMessages.welcome_to_pilotly);
				welcome.registerSubText = this.props.intl.formatMessage(localeMessages.match);
				welcome.message = this.props.intl.formatMessage(localeMessages.message, { group_name: group_name }) + " " + this.props.intl.formatMessage(localeMessages.create_profile);
				welcome.ctaButton = this.props.intl.formatMessage(localeMessages.button_create_profile);
			}
		} 
		else {
			welcome.registerTitle = this.props.intl.formatMessage(localeMessages.welcome_to_pilotly);
			welcome.registerSubText = this.props.intl.formatMessage(localeMessages.match);
		}

		welcome.message = fetchedGroup && fetchedGroup.welcome_message ? fetchedGroup.welcome_message : welcome.message;
		if (fetchedGroup && fetchedGroup.panel_segment && targetParams && targetParams.ps) {
			const ps = Number(targetParams.ps);
			if (ps < fetchedGroup.panel_segment.length && fetchedGroup.panel_segment[ps].welcome_message) {
				welcome.message = fetchedGroup.panel_segment[ps].welcome_message;
			}
		}

		return welcome;
	}

	checkForNewRegistration(currentUser, targetParams) {
		if ((currentUser && targetParams && targetParams.fakeUser && currentUser.email === targetParams.fakeUser.email) || 
			(currentUser && targetParams && !targetParams.fakeUser)) {
			return false;
		}
		return true;
	}

	async checkUserCompletionStatus(authedUser, group_id) {
		const { targetParams, globalAnalyticsAdapter, fetchedGroup } = this.props;
		const { userStudyStatus } = this.state;
		const isPartner = targetParams && targetParams.partner;
		const isDistList = targetParams && targetParams.dl;
		if (authedUser.subscriptions 
			&& authedUser.subscriptions.list 
			&& authedUser.subscriptions.group 
			&& (authedUser.subscriptions.list.length || authedUser.subscriptions.group.length)
		) {
			for (let spIndex = 0; spIndex < SUB_PARAMS.length; spIndex++) {
				let subParam = SUB_PARAMS[spIndex];

				for (let i = 0; i < authedUser.subscriptions[subParam].length; i++) {
					let groupSubscription = authedUser.subscriptions[subParam][i];
					if(groupSubscription.group_id === group_id && groupSubscription.complete) {

						const FEEDBACK_REDIRECT = SessionStatusEvent.FEEDBACK_REDIRECT.replace("[type]", 'CompletedChecked');
						let sessionStatus = new SessionStatus(FEEDBACK_REDIRECT, '', '', false, false, true);
						sessionStatus.gaTracker = this.props.tracker;
						sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
						sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
						globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

						// Ensure question assignment is updated to complete
						const panelSegmentIndex = targetParams.panelSegmentIndex || targetParams.ps;
						const panelSegment = fetchedGroup && fetchedGroup.panel_segment && fetchedGroup.panel_segment[panelSegmentIndex];
						const survey_id = panelSegment && (panelSegment.survey_id || panelSegment.panel);
						const user_token = auth.getToken();

						this.setState({userStudyStatus: "completed"}, () => {
							if (survey_id) {
								try {
									completeAllUserQuestionAssignments(authedUser.user_id, user_token, {
										group_id,
										panel_segment_index: parseInt(panelSegmentIndex),
										survey_id,
										complete: 1,
									});
								} catch (error) {
									Logger.log(this.constructor.name, "checkUserCompletionStatus() completeAllUserQuestionAssignments error", error);
								}
							}
						});
						return;

					}
					else if (groupSubscription.group_id === group_id && groupSubscription.screened) {

						const FEEDBACK_REDIRECT = SessionStatusEvent.FEEDBACK_REDIRECT.replace("[type]", 'ScreenedChecked');
						let sessionStatus = new SessionStatus(FEEDBACK_REDIRECT, '', '', false, false, true);
						sessionStatus.gaTracker = this.props.tracker;
						sessionStatus.state = isPartner ? 'Partner User' : (isDistList ? 'Distribution List User' : 'Pilotly User');
						sessionStatus.type = isPartner ? targetParams.partner : (isDistList ? targetParams.publisher : 'Pilotly');
						globalAnalyticsAdapter.reportAnalyticsEvent(sessionStatus);

						this.setState({userStudyStatus: "screened"});
						return;
					}
				}
			}
			this.setState({ userStudyStatus: "ready" });
		}
	}

	async submit(isNewRegistration) {
		if (isNewRegistration) { this.saveUser(); }
		else { this.validateAuthedUser(); }
	}

	validateEnvironment() {

		let isValidEnvironment = false;

		const {
			fetchedGroup,
			targetParams
		} = this.props;

		const panelSegmentIndex = parseInt(targetParams.ps);
		const panelSegments = fetchedGroup.panel_segment;

		if (panelSegments && panelSegments.length > panelSegmentIndex) {

			const panelSegment = panelSegments[panelSegmentIndex];
			const isDesktopStudy = isDesktopEnabledStudy(panelSegment);
			const isMobileWebStudy = isMobileWebEnabledStudy(panelSegment);
			const reelchatStudy = helpers.isReelChatStudy(targetParams);

			if (DeviceHelper.isDesktop) {
				const isFirefoxBrowser = helpers.isFirefoxBrowser(DeviceHelper.browser);
				isValidEnvironment = reelchatStudy || (isDesktopStudy && !isFirefoxBrowser);
			}
			else if (DeviceHelper.isMobile) {
				const isValidMobileBrowser = (DeviceHelper.isAndroid && DeviceHelper.isChrome) || (DeviceHelper.isIOS && DeviceHelper.isSafari && !DeviceHelper.isSafariViewController);
				isValidEnvironment = !reelchatStudy && isMobileWebStudy && isValidMobileBrowser && !DeviceHelper.isTablet;
			}
		}

		this.setState({ isValidEnvironment });
		return isValidEnvironment;
	}

	/***** renders *****/
	renderReadyMessage(targetParams, groupPoster, welcomeDisplay, isNewRegistration, registerFields) {
		const { currentUser } = this.props;
		const registrationCallback = async () => {
			if (targetParams && targetParams.vo === "1" && !currentUser) {
				const updatedTargetParams = cloneDeep(targetParams);
				const fakeUser = TargetProcess.createFakeUser(updatedTargetParams, true);
				const user = { ...this.state.user };
				
				user.age = (currentUser && currentUser.age) || user.age || fakeUser.age;
				user.gender = (currentUser && currentUser.gender) || user.gender || fakeUser.gender;
				user.zipcode = (currentUser && currentUser.zipcode) || user.zipcode || fakeUser.zipcode;
				
				if (targetParams && targetParams.hhi && targetParams.hhi === "1") {
					user.hhi = currentUser.hhi || user.hhi || fakeUser.hhi;
				}

				if (!currentUser) {
					updatedTargetParams.fakeUser = fakeUser;
					this.props.setTargetParams(updatedTargetParams);
				}

				this.setState({ user }, () => this.saveUser());
			}
			else if (registerFields && registerFields.length) {
				this.setState({ displayRegistration: true }, () => this.props.setPanelPartner(null));
			}
			else if (isNewRegistration) {
				this.saveUser();
			}
			else {
				this.validateAuthedUser();
			}

			if (this.state.requiresTechCheck && !this.props.techCheckFinished) {
				this.props.history.push("/tech-check");
			}
		};

		if (targetParams && targetParams.partner) {
			switch (targetParams.partner) {
				case 'alida': {
					return (
						<AmazonRegisterToBegin
							continueRegistration={this.state.continueRegistration}
							groupPoster={groupPoster}
							welcomeDisplay={welcomeDisplay}
							enableRegistration={registrationCallback}
						/>
					);
				}
				case 'qualtrics': {
					return (
						<QualtricsReadyToBegin
							continueRegistration={this.state.continueRegistration}
							groupPoster={groupPoster}
							welcomeDisplay={welcomeDisplay}
							enableRegistration={registrationCallback}
						/>
					);
				}
			}
		}

		return (
			<RegisterReadyToBegin
				continueRegistration={this.state.continueRegistration}
				groupPoster={groupPoster}
				welcomeDisplay={welcomeDisplay}
				enableRegistration={registrationCallback}
			/>
		);
	}

	renderRegisterFields(fieldStep, errors, user, parentGuardian, steps, getRefNames) {
		const { targetParams, fetchedGroup } = this.props;

		let registerFields = [];
		let refNames = [];
		let stepCount = 0;
		const isParent = parentGuardian.type === "parent";
		const isChild = parentGuardian.type === "child";
		const isDemo = targetParams && isNumber(targetParams.demo) && Number(targetParams.demo) === 1;
		const isReelChat = helpers.isReelChatStudy(targetParams);

		// let currentUser = this.props.currentUser ? { ...this.props.currentUser } : { ...this.state.user };
		let userAge = user.age ? user.age : Math.round(moment().diff(user.dob || user.date_of_birth, 'years', true));

		steps.forEach((step) => {
			let formLock = fieldStep !== stepCount ? " form-lock" : "";
			if (step === "viewer_description" && targetParams && targetParams.guidance) {
				refNames.push("_viewerDiscription");

				registerFields.push(
					<div key={"viewer-discription-step-" + stepCount} 
						id="viewer-discription-field" 
						className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p className="mb-10">
							Which of the following best describes you
						</p>

						<div className="width-100p">
							<div>
								<div className="inline-block parental-checkbox mr-10 mb-5"
									onClick={() => this.handleParentGuardian('parent')}>
									<i className={"fa fa-check checkmark" + (parentGuardian.type === "parent" ? "" : " opacity-0p")}></i>
								</div>
								<div className="inline-block">
									<p className="detail-label">Parent/Guardian of viewer that is 17 of age or younger</p>
								</div>
							</div>

							<div>
								<div className="inline-block parental-checkbox mr-10"
									onClick={() => this.handleParentGuardian('child')}>
									<i className={"fa fa-check checkmark" + (parentGuardian.type === "child" ? "" : " opacity-0p")}></i>
								</div>
								<div className="inline-block">
									<p className="detail-label">Viewer that is 17 of age or younger</p>
								</div>
							</div>
						</div>

						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('fullname', true, e)}>
							Next
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "fullname" && (!targetParams || (targetParams && !targetParams.fakeUser) || isModerated(targetParams, fetchedGroup))) {
				// first name
				refNames.push("_fullname");

				let fullname = "";
				if (!targetParams || !user.fullname.startsWith(targetParams.partner)) {
					fullname = user.fullname;
				}

				registerFields.push(
					<div key={"fullname-step-" + stepCount} id="fullname-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p>
							<FormattedMessage
								id="register.form.name"
								defaultMessage={`What's your {name} ?`}
								values={{ name: <b>{this.props.intl.formatMessage(localeMessages.name)}</b> }}
							/>
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.name_detail"
								defaultMessage={`We're excited to get to know you (enter first and last name)`}
							/>							
						</p>
						<input name="fullname" type="text" className="validate" onChange={this.handleChange}
							value={fullname} onKeyUp={(e) => this.handleNext('fullname', false, e)}
							disabled={formLock} ref={this._fullname} />
						<p className={"register-error" + (errors.fullname ? "" : " hide")}>{errors.fullname}</p>

						{/*<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.validateText('fullname', true, e)}>
							Next
						</button>*/}
						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('fullname', true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>							
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "email" 
				&& (!targetParams || (targetParams && !targetParams.fakeUser))
				&& !isDemo
			) {
				// email address
				refNames.push("_email");
				registerFields.push(
					<div key={"email-step-" + stepCount} id="email-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p>
							<FormattedMessage
								id="register.form.email_address"
								defaultMessage={`What's your {email_address} ?`}
								values={{ email_address: <b>{this.props.intl.formatMessage(localeMessages.email_address)}</b> }}
							/>
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.email_address_detail"
								defaultMessage={`What's the best way to reach you?`}
							/>							
						</p>
						<input name="email" type="email" className="validate" onChange={this.handleChange}
							value={user.email} onKeyUp={(e) => this.handleNext("email", false, e)}
							disabled={formLock} ref={this._email} />
						<p className={"register-error" + (errors.email ? "" : " hide")}>{errors.email}</p>

						<Button
							onClick={(e) => this.handleNext("email", true, e)}
							wrapClass="pull-right"
							buttonClass="register-field-submit"
							formLock={formLock}
							activated={this.state.buttonWaiting}
						>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>							
						</Button>
					</div>
				);
				stepCount++;
			}

			// !demo
			if (step === "date_of_birth" 
				&& (!targetParams || (targetParams && !targetParams.partner && !targetParams.client && !isValidAge(targetParams.age)))
				&& !isDemo
			) {
				// birth date
				refNames.push("_dateOfBirth");
				registerFields.push(
					<div key={"date_of_birth-step-" + stepCount} 
						id="date_of_birth-field" 
						className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p className="mb-5">
							<FormattedMessage
								id="register.form.birth_date"
								defaultMessage={`What's your {birth_date} ?`}
								values={{ birth_date: <b>{this.props.intl.formatMessage(localeMessages.birth_date)}</b> }}
							/>
						</p>
						{/* Commented out for now. We'll want to add this back in with new copy
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.birth_date_detail"
								defaultMessage={`We want to make sure we show you appropriate videos`}
							/>							
						</p> */}
						<input 
							name="date_of_birth" 
							type="text" 
							className="validate" 
							onChange={(e) => this.handleDateChange(e, isParent)} 
							placeholder={this.props.intl.formatMessage(localeMessages.birth_date_placeholder)} // INTL:DATE
							maxLength={10} 
							value={isParent ? parentGuardian.date_of_birth : user.date_of_birth}
							onKeyUp={(e) => this.handleNext("date_of_birth", false, e, isParent)}
							disabled={formLock}
							ref={this._dateOfBirth} />
						<p className={"register-error" + (errors.date_of_birth ? "" : " hide")}>{errors.date_of_birth}</p>

						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext("date_of_birth", true, e, isParent)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>							
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "date_of_birth" 
				&& ((targetParams && !isValidAge(targetParams.age) && (targetParams.partner || targetParams.client)) || isDemo)
			) {
				// age
				refNames.push("_dateOfBirth");
				registerFields.push(
					<div key={"age-step-" + stepCount} 
						id="age-field" 
						className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p className="mb-5">
							<FormattedMessage
								id="register.form.age"
								defaultMessage={`What's your {age} ?`}
								values={{ age: <b>{this.props.intl.formatMessage(localeMessages.age)}</b> }}
							/>
						</p>
						{/* <p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.age_detail"
								defaultMessage={`We want to make sure we show you appropriate videos`}
							/>							
						</p> */}
						<input 
							name="age" 
							type="number" 
							className="validate" 
							onChange={(e) => this.handleChange(e, isParent)}
							maxLength={10} 
							value={isParent ? parentGuardian.age : user.age} 
							onKeyUp={(e) => this.handleNext("age", false, e, isParent)}
							disabled={formLock} 
							ref={this._dateOfBirth} 
						/>
						<p className={"register-error" + (errors.age ? "" : " hide")}>{errors.age}</p>

						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('age', true, e, isParent)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>							
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "child_date_of_birth" && isParent) {
				refNames.push("_childDateOfBirth");
				registerFields.push(
					<div key={"age-step-" + stepCount}
						id="age-field"
						className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p className="mb-5">
							<FormattedMessage
								id="register.form.age.child"
								defaultMessage={`What's your child's {age} ?`}
								values={{ age: <b>{this.props.intl.formatMessage(localeMessages.age)}</b> }}
							/>
						</p>
						{/* <p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.child_age_detail"
								defaultMessage={`We want to make sure we show your child's appropriate videos`}
							/>
						</p> */}
						<input
							name="age"
							type="number"
							className="validate"
							onChange={this.handleChange}
							maxLength={10}
							value={user.age}
							onKeyUp={(e) => this.handleNext("age", false, e)}
							disabled={formLock}
							ref={this._childDateOfBirth}
						/>
						<p className={"register-error" + (errors.child_age ? "" : " hide")}>{errors.child_age}</p>

						<button 
							className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('age', true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "parental_consent" && (targetParams && targetParams.afc && targetParams.afc >= userAge)) {
				refNames.push("_parentalConsent");
				registerFields.push(
					<div key={"parental-consent-step-" + stepCount} 
						id="parental-consent-field" 
						className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p className={(fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.parental_consent"
								defaultMessage={`Your parent/guardian must read and consent to the following before you may proceed.`}
								values={{ consent: <b>{this.props.intl.formatMessage(localeMessages.consent)}</b> }}
							/>
						</p>
						<p className={"mt-10"}>
							<FormattedMessage
								id="register.form.parental_consent_date_detail"
								defaultMessage={`Do you give consent to your {userAge} year old to participate in this study?`}
								values={{ userAge: userAge }}
							/>
						</p>
						<div className="btn-group mt-5">
							<button className={"toggle-flat-btn" + (parentGuardian.parental_consent ? " active" : "") + (parentGuardian.consent === "f" ? "" : " border-right")}
								onClick={() => this.handleParentalConsent(true)}
								disabled={formLock}>
								<FormattedMessage
									id="register.form.consent.yes"
									defaultMessage={`Yes`}
								/>
							</button>

							<button className={"toggle-flat-btn" + (!parentGuardian.parental_consent ? " active" : "")}
								onClick={() => this.handleParentalConsent(false)}
								disabled={formLock}>
								<FormattedMessage
									id="register.form.consent.no"
									defaultMessage={`No`}
								/>
							</button>
						</div>

						<p className={"register-error" + (errors.gender ? "" : " hide")}>{errors.gender}</p>
						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext("parental_consent", true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "gender" && (!targetParams || !formatGender(targetParams.gender))) {
				// gender
				let addGenderNeutral = this.state.addGenderNeutral;
				refNames.push("_gender");
				registerFields.push(
					<div key={"gender-step-" + stepCount} 
						id="gender-field" 
						className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p>
							{isParent ?
								<FormattedMessage
									id="register.form.gender.child"
									defaultMessage={`What is your child's {gender} ?`}
									values={{ gender: <b>{this.props.intl.formatMessage(localeMessages.gender)}</b> }}
								/>
								:
								<FormattedMessage
									id="register.form.gender"
									defaultMessage={`What is your {gender} ?`}
									values={{ gender: <b>{this.props.intl.formatMessage(localeMessages.gender)}</b> }}
								/>
							}
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.gender_detail"
								defaultMessage={`Let us know how you identify`}
							/>
						</p>
						<div className="btn-group">
							<button className={"toggle-flat-btn" + (user.gender === "f" ? " active" : "") + (user.gender === "f" ? "" : " border-right")}
								onClick={() => this.handleGenderChange('f')}
								disabled={formLock}>
								<FormattedMessage
									id="register.form.gender.female"
									defaultMessage={`Female`}
								/>							
							</button>

							<button className={"toggle-flat-btn" + (user.gender === "m" ? " active" : "") + (user.gender === "m" ? "" : (addGenderNeutral ? " border-right" : ""))}
								onClick={() => this.handleGenderChange('m')}
								disabled={formLock}>
								<FormattedMessage
									id="register.form.gender.male"
									defaultMessage={`Male`}
								/>							
							</button>

							{this.state.addGenderNeutral ? 
								<button className={"toggle-flat-btn" + (user.gender === "z" ? " active" : "")}
									onClick={() => this.handleGenderChange('z')}
									disabled={formLock}>
									<FormattedMessage
										id="register.form.gender.neutral"
										defaultMessage={`Non-binary`}
									/>
								</button>
								:
								""
							}
						</div>

						<p className={"register-error" + (errors.gender ? "" : " hide")}>{errors.gender}</p>
						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext("gender", true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>							
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "country" && (targetParams && targetParams.country === '1')) {
				// country
				refNames.push("_country");
				let countryOptions = [];
				for (let countryCode in localeCountry) {
					let countryObj = localeCountry[countryCode];
					if (countryCode === 'select') {
						countryOptions.push(
							<option key={countryObj.id} value="" disabled>
								{this.props.intl.formatMessage(countryObj)}
							</option>
						);
					}
					else {
						countryOptions.push(
							<option key={countryObj.id} 
								value={countryObj.code}>
								{this.props.intl.formatMessage(countryObj)}
							</option>
						);
					}
				}

				registerFields.push(
					<div key={"country-step-" + stepCount} id="country-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)} disabled={fieldStep > stepCount}>
						<p>
							<FormattedMessage
								id="register.form.country"
								defaultMessage={`What is your country of residence ?`}
							/>
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.location"
								defaultMessage={`The creator of this study would like to know your location`}
							/>
						</p>
						<select id="country" value={user.country} disabled={fieldStep > stepCount}
							ref={this._country}>
							{countryOptions}
						</select>

						<p className={"register-error" + (errors.country ? "" : " hide")}>{errors.country}</p>

						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('country', true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "zipcode" && !user.isInternationalUser && (!targetParams || !targetParams.zipcode)) {
				// zipcode
				refNames.push("_zipcode");
				registerFields.push(
					<div key={"zipcode-step-" + stepCount} id="zipcode-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p>
							<FormattedMessage
								id="register.form.zipcode"
								defaultMessage={`What's your {zipcode} ?`}
								values={{ zipcode: <b>{this.props.intl.formatMessage(localeMessages.zipcode)}</b> }}
							/>
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.zipcode_detail"
								defaultMessage={`What area do you live in?`}
							/>							
						</p>
						<input name="zipcode" type="text" className="validate" onChange={this.handleChange}
							value={user.zipcode} onKeyUp={(e) => this.handleNext('zipcode', false, e)}
							disabled={formLock} ref={this._zipcode} />
						<p className={"register-error" + (errors.zipcode ? "" : " hide")}>{errors.zipcode}</p>

						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('zipcode', true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>							
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "household_income" && (targetParams && targetParams.hhi)) {
				// household income

				const lastYear = moment().subtract(1, 'years').format('YYYY');
				refNames.push("_houseHoldIncome");
				registerFields.push(
					<div key={"household_income-step-" + stepCount} id="household_income-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p>
							<FormattedMessage
								id="register.form.household_income"
								defaultMessage={`What was your total income in the year {year} ?`}
								values={{ year: <b>{lastYear}</b> }}
							/>
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.household_income_detail"
								defaultMessage={`The creator of this study is curious about income levels {instruction}`}
								values={{ instruction: <b>(whole numbers only please)</b> }}
							/>
						</p>
						<input name="household_income" type="number" className="validate" onChange={this.handleChange}
							value={user.household_income} 
							disabled={formLock} ref={this._houseHoldIncome}
							onKeyUp={(e) => this.handleNext("household_income", false, e)}
							onKeyDown={(e) => this.handleHouseholdIncomeKeyDown(e)}
							onPaste={(e) => this.handleHouseholdIncomePaste(e)}
							pattern='[0-9]'/>
						<p className={"register-error" + (errors.household_income ? "" : " hide")}>{errors.household_income}</p>
						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext("household_income", true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "ethnicity_hispanic" && !user.isInternationalUser && (!targetParams || targetParams.eth !== '0')) {
				// ethnicity 
				refNames.push("_ethnicityHispanic");
				registerFields.push(
					<div key={"ethnicity-step-" + stepCount} id="ethnicity_hispanic-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p>
							{isParent ?
								<FormattedMessage
									id="register.form.ethnicity.child.hispanic"
									defaultMessage={`Is your child Hispanic, Latino or of Spanish descent ?`}
								/>
								:
								<FormattedMessage
									id="register.form.ethnicity.hispanic"
									defaultMessage={`Are you of Hispanic, Latino, or Spanish descent ?`}
								/>
							}
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.ethnicity_detail.hispanic"
								defaultMessage={`For this study it would be helpful to know a bit more about your background`}
							/>							
						</p>
						<div className="btn-group">
							<button className={"toggle-flat-btn" + (user.ethnicity_hispanic === 1 ? " active" : "") + (user.ethnicity_hispanic ? "" : " border-right")}
								onClick={() => this.handleHispanicSubmit(1)}
								disabled={formLock}>
								<FormattedMessage
									id="register.form.hispanic.yes"
									defaultMessage={`Yes`}
								/>
							</button>

							<button className={"toggle-flat-btn" + (user.ethnicity_hispanic === 0 ? " active" : "")}
								onClick={() => this.handleHispanicSubmit(0)}
								disabled={formLock}>
								<FormattedMessage
									id="register.form.hispanic.no"
									defaultMessage={`No`}
								/>
							</button>
						</div>

						<p className={"register-error"+  (errors.ethnicity ? "" : " hide")}>{ errors.ethnicity }</p>
						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext("ethnicity_hispanic", true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>							
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "ethnicity_race" && !user.isInternationalUser && (!targetParams || targetParams.eth !== '0')) {
				// ethnicity 
				refNames.push("_ethnicityRace");
				registerFields.push(
					<div key={"ethnicity-race-step-" + stepCount} id="ethnicity_race-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount) + (user.ethnicity_race.length ? " valid" : "")}>
						<p>
							{isParent ?
								<FormattedMessage
									id="register.form.ethnicity.child"
									defaultMessage={`Which of the following best describes your child's {race} (select all that apply) ?`}
									values={{ race: <b>{this.props.intl.formatMessage(localeMessages.race)}</b> }}
								/>
								:
								<FormattedMessage
									id="register.form.ethnicity"
									defaultMessage={`Which of the following best describes your {race} (select all that apply) ?`}
									values={{ race: <b>{this.props.intl.formatMessage(localeMessages.race)}</b> }}
								/>
							}
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.ethnicity_detail"
								defaultMessage={`For this study it would be helpful to know a bit more about your background`}
							/>
						</p>
						<select id="ethnicity" multiple onChange={this.handleEthnicitySelect} value={user.race} disabled={fieldStep > stepCount}
							ref={this._ethnicityRace}>
							<option value="" disabled>{this.props.intl.formatMessage(localeEthnicity.select)}</option>
							<option value={AMERICAN_INDIAN}>{this.props.intl.formatMessage(localeEthnicity.american_indian)}</option>
							<option value={ASIAN_INDIAN}>{this.props.intl.formatMessage(localeEthnicity.asian_indian)}</option>
							<option value={AFRICAN_AMERICAN}>{this.props.intl.formatMessage(localeEthnicity.african_american)}</option>
							<option value={NATIVE_HAWAIIAN_PACIFIC_ISLANDER}>{this.props.intl.formatMessage(localeEthnicity.pacific_islander)}</option>
							<option value={CAUCASIAN_WHITE}>{this.props.intl.formatMessage(localeEthnicity.white)}</option>
							<option value={OTHER}>{this.props.intl.formatMessage(localeEthnicity.other)}</option>
							<option value={NOT_AVAILABLE}>{this.props.intl.formatMessage(localeEthnicity.decline)}</option>
						</select>

						<p className={"register-error" + (errors.ethnicity ? "" : " hide")}>{errors.ethnicity}</p>
						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext("ethnicity_race", true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "education" && (targetParams && targetParams.ed)) {
				// education
				refNames.push("_education");
				registerFields.push(
					<div key={"education-step-" + stepCount} id="education-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)} disabled={fieldStep > stepCount}>
						<p>
							{isParent ?
								<FormattedMessage
									id="register.form.education.child"
									defaultMessage={`What is your child's level of {education} ?`}
									values={{ education: <b>{this.props.intl.formatMessage(localeMessages.education)}</b> }}
								/>
								:
								<FormattedMessage
									id="register.form.education"
									defaultMessage={`What is your level of {education} ?`}
									values={{ education: <b>{this.props.intl.formatMessage(localeMessages.education)}</b> }}
								/>
							}
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.education_detail"
								defaultMessage={`The creator of this study is curious about education levels`}
							/>
						</p>
						<select id="education" onChange={this.handleEducationSelect} value={user.education} disabled={fieldStep > stepCount}
							ref={this._education}>
							<option value="" disabled>{this.props.intl.formatMessage(localeEducation.select)}</option>
							<option value={0}>{this.props.intl.formatMessage(localeEducation.some_high_school)}</option>
							<option value={1}>{this.props.intl.formatMessage(localeEducation.high_school)}</option>
							<option value={2}>{this.props.intl.formatMessage(localeEducation.some_college)}</option>
							<option value={3}>{this.props.intl.formatMessage(localeEducation.college)}</option>
							<option value={4}>{this.props.intl.formatMessage(localeEducation.post_graduate)}</option>
						</select>

						<p className={"register-error" + (errors.education ? "" : " hide")}>{errors.education}</p>

						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('education', true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>
						</button>
					</div>
				);
				stepCount++;
			}

			if (step === "password" 
				&& (!targetParams || (targetParams && !targetParams.fakeUser))
				&& !isDemo
				&& !isReelChat
			) {
				// password
				refNames.push("_password");
				registerFields.push(
					<div key={"password-step-"+ stepCount} id="password-field" className={"input-field col s12 transition-field" + formLock + this.getInputFieldClass(stepCount)}>
						<p>
							<FormattedMessage
								id="register.form.password"
								defaultMessage={`Create your {password}`}
								values={{ password: <b>{this.props.intl.formatMessage(localeMessages.password)}</b> }}
							/>
						</p>
						<p className={"detail-label" + (fieldStep > stepCount ? " hide" : "")}>
							<FormattedMessage
								id="register.form.password_detail"
								defaultMessage={`To keep it secure use over 8 characters, including letters and numbers`}
							/>							
						</p>
						<input name="password" type="password" className="validate" onChange={this.handleChange}
							value={user.password} onKeyUp={(e) => this.handleNext('password', false, e)}
							disabled={formLock} ref={this._password}/>
						<p className={"register-error"+  (errors.password ? "" : " hide")}>{ errors.password }</p>

						<button className={"waves-effect waves-light btn register-field-submit pull-right" + (formLock ? " display-none" : "")}
							onClick={(e) => this.handleNext('password', true, e)}>
							<FormattedMessage
								id="register.form.button.next"
								defaultMessage={`Next`}
							/>
						</button>
					</div>
				);
				stepCount++;
			}
		});

		return getRefNames ? refNames : registerFields;
	}

	render() {
		Logger.log(this.constructor.name, "render() PROPS:", this.props, "STATE:", this.state);

		let { targetParams } = this.props;

		const isReelChat = helpers.isReelChatStudy(targetParams);
		const isTester = helpers.isTesterFromUrl() || (targetParams && targetParams.test === "1");

		if (!isReelChat && !isTester && (!targetParams || targetParams.provider === "pilotly-user")) {
			return <Redirect to="/non-partner-restricted" />;
		}

		let fieldStep = this.state.step;
		let errors = {...this.state.errors};
		let hasErrors = errors && Object.keys(errors).length;
		let user = {...this.state.user};
		let parentGuardian = {...this.state.parentGuardian};
		let registerFields = this.renderRegisterFields(fieldStep, errors, user, parentGuardian, this.state.steps);
		let currentField = registerFields[fieldStep] ? registerFields[fieldStep].props.id.replace("-field", "") : "";
		let welcomeDisplay = this.getWelcomeDisplay(targetParams, this.props.fetchedGroup);

		let groupPoster = this.props.fetchedGroup ? this.getGroupPoster(this.props.fetchedGroup) : null;
		let feedbackType = this.getUserFeedbackDisplay();
		let isNewRegistration = this.checkForNewRegistration(this.props.currentUser, targetParams);
		
		// return feedback component if redirects are needed
		if(feedbackType) {
			return <Feedback {...this.props} feedbackType={feedbackType}/>;
		}

		let slideUpActive = currentField === "ethnicity_race" || currentField === "education" || currentField === "country";
		// let thirdPartyStudy = targetParams && (targetParams.partner || targetParams.dl);

		let partnerClass = this.getPartnerClass(targetParams);

		let readyToBeginMessage = this.renderReadyMessage(targetParams, groupPoster, welcomeDisplay, isNewRegistration, registerFields);

		const displayRegistration = this.state.displayRegistration || (this.state.requiresTechCheck && this.props.techCheckFinished);

		const renderRegistration = displayRegistration && !this.state.realUser && registerFields.length;

		const previousButton = (
			<div className="previous-form-step mb-15" onClick={() => this.handlePrevious()}>
				<i className="far fa-arrow-alt-circle-left"></i>
			</div>
		);

		const nextButton = (
			<div className="next-form-step pull-right" onClick={user[currentField] ? (e) => this.handleNext(currentField, true, e) : null}>
				<i className={"far fa-arrow-alt-circle-right" + (user[currentField] ? "" : " disable")}></i>
			</div>
		);

		return (
			<div className={`pilotly-register ${partnerClass}`}>
				<PageLoader loading={(!displayRegistration && !this.props.fetchedGroup) || this.state.loading} small={true} />

				<FadeIn>
					<div className={DeviceHelper.isMobile && !renderRegistration ? 'ready-to-begin-wrapper' : ('register-form-wrapper' + (DeviceHelper.isMobile ? ' register-form-wrapper-mobile' : ''))}>
						{renderRegistration ?
							<div className="row">
								<FadeIn>
									<div className={"pilotly-register-form col s8" + (slideUpActive ? " active" : "") + (DeviceHelper.isMobile ? ' pilotly-register-form-mobile' : '')}>
										
										{ DeviceHelper.isMobile ?
											<div className='register-navigation-buttons'>
												{
													previousButton
												}
												{
													nextButton
												}
											</div> : ''
										}

										<div className={DeviceHelper.isMobile ? 'register-form-mobile' : null}>
											<div className={"register-form-message" + (fieldStep > 0 ? " hideout" : "")}>
												<h3>{welcomeDisplay.registerTitle}</h3>
												<p>{welcomeDisplay.registerSubText}</p>
											</div>

											<div className={"field-group" + (fieldStep > 0 ? " active" : "") + (!welcomeDisplay.registerSubText ? " without-subtext" : "")}>
												<p className="detail-label">
													{this.state.step + 1} <FormattedMessage
														id="register.form.of"
														defaultMessage={`of`}
													/> {registerFields.length + 1}
												</p>

												<div className={"form-navigation" + (fieldStep > 0 ? " active" : "")}>
													<div className="previous-form-step mb-15" onClick={() => this.handlePrevious()}>
														<i className={"far fa-arrow-alt-circle-up" + (fieldStep === 0 ? " disable" : "")}></i>
													</div>

													<div className="next-form-step"
														onClick={user[currentField] ? (e) => this.handleNext(currentField, true, e) : null}>
														<i className={"far fa-arrow-alt-circle-down" + (user[currentField] && !hasErrors ? "" : " disable")}></i>
													</div>
												</div>

												{registerFields}

												<div className={"input-field col s12 transition-field submit" + this.getInputFieldClass(registerFields.length)}>
													<div className="form-group">
														<p>
															<FormattedMessage
																id="register.form.agree_to_terms"
																defaultMessage={`Pilotly provides anonymized versions of any data you enter, or any feedback you submit, to content creators in order to help them improve their content. By clicking Submit you acknowledge that you agree to Pilotly’s {terms_of_service} and {privacy_policy}`}
																values={{ 
																	terms_of_service: <Link to="/terms-and-conditions" target="_blank"><u>{this.props.intl.formatMessage(localeMessages.terms_of_service)}</u></Link>,
																	privacy_policy: <Link to="/privacy-policy" target="_blank"><u>{this.props.intl.formatMessage(localeMessages.privacy_policy)}</u></Link>
																}}
															/>
														</p>

														<button className="waves-effect waves-light btn register-field-submit"
															onClick={() => this.submit(isNewRegistration)}>
															<FormattedMessage
																id="register.form.button.submit"
																defaultMessage={`Submit`}
															/>							
														</button>
													</div>
												</div>

												{ !DeviceHelper.isMobile ?
													<div className={"sub-form-navigation col s12" + (fieldStep > 0 ? " active" : "")}>
														{
															previousButton
														}
														{
															nextButton
														}
													</div>
													: ''
												}
											</div>
										</div>

									</div>
								</FadeIn>
							</div>
							:
							<div className="row ready-to-begin">
								{!displayRegistration && !this.props.fetchedGroup ?
									""
									:
									readyToBeginMessage
								}
							</div>
						}

						{/*<Errors errors={this.state.errors} />*/}
					</div>
				</FadeIn>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentUser: state.currentUser.currentUser,
		currentUserLocation: state.currentUser.currentUserLocation,
		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedEpisode: state.targetProcess.fetchedEpisode,
		fetchedGroup: state.targetProcess.fetchedGroup,
		panelPartner: state.targetProcess.panelPartner,
		targetParams: state.targetProcess.targetParams,
		userDisclaimer: state.currentUser.userDisclaimer,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
		techCheckFinished: state.techCheck.techCheckFinished,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setFetchedDistributionList,
		setFetchedEpisode,
		setFetchedGroup,
		setFetchedGroupPanelSegment,
		setFetchedPanel,
		setTargetParams,
		setCurrentUser,
		setUserDisclaimer,
		setPanelPartner
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Register));



// WEBPACK FOOTER //
// ./src/pages/Register.js